<template>
  <section id="hero-section">
    <div class="hero-slider boxed">
      <div
        :class="[
          activeslide === 1
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div class="hero-text">
          <h1 class="inner" style="--delay: 0.1s">
            <b>Complete</b> end to end <b>Digitalization</b> towards a
            <b>Paperless</b> Platform For <b>Pharma</b> & Lab
          </h1>
          <h2 class="inner" style="--delay: 0.2s">
            Plan, document and organise your experiments with ease and
            efficiency
          </h2>
          <div class="cta inner" style="--delay: 0.4s">
            <button class="primary btn">
              <a href="#sign-up">Try Now</a>
            </button>
          </div>
        </div>
        <div class="hero-image right">
          <img
            class="img hero-tablet"
            src="../assets/img/hero-tablet-min.png"
            alt="A Tablet View with Digital GxP application loaded on screen"
          />
        </div>
      </div>

      <div
        :class="[
          activeslide === 2
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div class="hero-image left">
          <img
            class="img"
            src="../assets/img/tree-device-mockup-min.png"
            alt="Tablet, Laptop and mobile devices with Digital GxP application loaded on screen"
            loading="lazy"
          />
        </div>

        <div class="hero-text">
          <h3 class="slide inner" style="--delay: 0.1s">
            <b>Digital Documentation</b><br />
            towards <b>Pharma 4.0</b>
          </h3>
          <h2 class="list inner" style="--delay: 0.2s">Create Video SOPs</h2>
          <h2 class="list inner" style="--delay: 0.3s">
            Free PDF to Digital Conversion
          </h2>
          <h2 class="list inner" style="--delay: 0.4s">
            Traceability at Every Step
          </h2>
          <h2 class="list inner" style="--delay: 0.5s">
            Static to Dymanic Platform
          </h2>
          <div class="cta inner" style="--delay: 0.6s">
            <button class="primary btn">
              <a href="#sign-up">Create a Free Account</a>
            </button>
          </div>
        </div>
      </div>

      <div
        :class="[
          activeslide === 3
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div class="hero-text">
          <h2 class="slide inner" style="--delay: 0.1s">
            Do you face these challenges in your Lab/Organization?
          </h2>

          <h3 class="slide inner" style="--delay: 0.3s">
            We are <b>solving</b><br />
            <b>Documentation Problems </b>
            in <b>Lab</b> & <b>Pharma</b>
          </h3>

          <div class="cta inner" style="--delay: 0.5s">
            <button class="primary btn">
              <a href="#sign-up">Sign Up Now</a>
            </button>
          </div>
        </div>
        <div>
          <ul class="problem-list right">
            <li class="problem" style="--degree: 181deg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.237305"
                  y="4.75244"
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="rotate(-45 0.237305 4.75244)"
                  fill="#D42E4C"
                />
                <rect
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 23.7627 4.75244)"
                  fill="#D42E4C"
                />
              </svg>
              <h4>Manual & Inefficient</h4>
            </li>

            <li class="problem" style="--degree: 178deg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.237305"
                  y="4.75244"
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="rotate(-45 0.237305 4.75244)"
                  fill="#D42E4C"
                />
                <rect
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 23.7627 4.75244)"
                  fill="#D42E4C"
                />
              </svg>
              <h4>Difficult to Follow</h4>
            </li>

            <li class="problem" style="--degree: 180deg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.237305"
                  y="4.75244"
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="rotate(-45 0.237305 4.75244)"
                  fill="#D42E4C"
                />
                <rect
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 23.7627 4.75244)"
                  fill="#D42E4C"
                />
              </svg>
              <h4>Data Entry Error</h4>
            </li>

            <li class="problem" style="--degree: 181deg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.237305"
                  y="4.75244"
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="rotate(-45 0.237305 4.75244)"
                  fill="#D42E4C"
                />
                <rect
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 23.7627 4.75244)"
                  fill="#D42E4C"
                />
              </svg>
              <h4>Lack of Visualization</h4>
            </li>

            <li class="problem" style="--degree: 179deg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.237305"
                  y="4.75244"
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="rotate(-45 0.237305 4.75244)"
                  fill="#D42E4C"
                />
                <rect
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 23.7627 4.75244)"
                  fill="#D42E4C"
                />
              </svg>
              <h4>Limited Traceability</h4>
            </li>

            <li class="problem" style="--degree: 178deg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.237305"
                  y="4.75244"
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="rotate(-45 0.237305 4.75244)"
                  fill="#D42E4C"
                />
                <rect
                  width="6.72098"
                  height="26.8839"
                  rx="2"
                  transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 23.7627 4.75244)"
                  fill="#D42E4C"
                />
              </svg>
              <h4>Limited Collaboration</h4>
            </li>
          </ul>
        </div>
      </div>

      <div
        :class="[
          activeslide === 4
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div
          class="hero-image left"
          data-aos="fade-right"
          data-aos-duration="2000"
        >
          <svg
            width="550"
            height="385"
            viewBox="0 0 550 385"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4_98)">
              <path
                d="M334.681 349.624H203.902C200.803 349.621 197.831 348.388 195.639 346.196C193.447 344.004 192.214 341.032 192.211 337.933V148.275C192.214 145.175 193.447 142.203 195.639 140.012C197.831 137.82 200.803 136.587 203.902 136.583H334.681C337.78 136.587 340.752 137.82 342.944 140.012C345.136 142.203 346.369 145.175 346.372 148.275V337.933C346.369 341.032 345.136 344.004 342.944 346.196C340.752 348.388 337.78 349.621 334.681 349.624Z"
                fill="#3F3D56"
              />
              <path
                d="M334.911 342.165H203.672C202.717 342.164 201.801 341.784 201.125 341.108C200.45 340.432 200.069 339.516 200.068 338.561V147.647C200.069 146.691 200.45 145.775 201.125 145.1C201.801 144.424 202.717 144.044 203.672 144.043H334.911C335.866 144.044 336.783 144.424 337.458 145.1C338.134 145.775 338.514 146.691 338.515 147.647V338.561C338.514 339.516 338.134 340.432 337.458 341.108C336.783 341.784 335.866 342.164 334.911 342.165Z"
                fill="white"
              />
              <path
                d="M210.075 231.891C210.442 226.917 211.047 220.801 215.968 218.144C218.291 216.89 220.75 217.333 223.085 218.311C225.341 219.255 227.466 220.381 229.896 220.825C234.085 221.548 238.395 220.902 242.188 218.982C246.007 217.083 249.072 213.946 250.883 210.083C251.814 208.118 252.585 205.989 253.957 204.275C254.648 203.374 255.564 202.672 256.612 202.238C257.661 201.804 258.805 201.654 259.93 201.803C265.091 202.44 268.515 206.962 272.63 209.624C274.608 210.904 276.88 211.839 279.276 211.724C281.733 211.606 283.961 210.443 285.844 208.924C289.84 205.702 292.025 200.719 296.219 197.716C298.207 196.328 300.514 195.465 302.925 195.209C305.337 194.953 307.774 195.311 310.009 196.25C314.307 198.104 317.35 202.259 318.154 206.83C318.347 207.957 318.397 209.103 318.302 210.242C318.25 210.913 319.297 210.91 319.349 210.242C319.506 207.872 319.113 205.499 318.201 203.306C317.289 201.114 315.882 199.162 314.091 197.603C310.381 194.402 305.197 193.362 300.483 194.593C298.082 195.23 295.876 196.449 294.06 198.144C292.12 199.933 290.59 202.1 288.953 204.155C287.355 206.159 285.593 208.094 283.351 209.389C282.278 210.043 281.075 210.456 279.826 210.598C278.577 210.74 277.312 210.608 276.119 210.211C273.699 209.395 271.649 207.713 269.713 206.103C267.717 204.443 265.73 202.782 263.331 201.727C261.101 200.747 258.543 200.271 256.221 201.237C254.127 202.107 252.742 203.915 251.715 205.87C250.672 207.854 249.93 209.994 248.714 211.886C247.537 213.697 246.028 215.268 244.265 216.516C240.684 219.074 236.331 220.318 231.939 220.038C229.553 219.868 227.384 219.114 225.223 218.127C222.838 217.036 220.327 215.903 217.643 216.431C215.329 216.886 213.381 218.459 212.029 220.337C210.468 222.506 209.783 225.165 209.425 227.776C209.237 229.142 209.13 230.517 209.029 231.891C208.98 232.563 210.026 232.56 210.075 231.891Z"
                fill="#E4E4E4"
              />
              <path
                d="M187.789 321.214L186.77 326.324C186.694 326.714 186.613 327.112 186.526 327.506C185.675 327.33 184.792 327.379 183.966 327.649C184.622 328.586 185.209 329.568 185.724 330.589C185.082 332.567 184.14 334.394 182.564 335.716C181.511 336.579 180.254 337.157 178.913 337.393C177.572 337.628 176.193 337.515 174.908 337.063L174.954 336.86C173.259 333.571 174.179 329.424 176.286 326.386C177.36 324.888 178.633 323.542 180.07 322.386C181.493 321.2 183.031 320.136 184.556 319.086C184.898 318.851 185.303 318.723 185.718 318.719C186.133 318.714 186.541 318.834 186.888 319.063C187.235 319.291 187.506 319.618 187.666 320.001C187.827 320.384 187.87 320.806 187.789 321.214Z"
                fill="#E4E4E4"
              />
              <path
                d="M175.27 349.357C174.842 346.235 174.401 343.072 174.701 339.916C174.969 337.113 175.824 334.376 177.565 332.131C178.489 330.942 179.613 329.923 180.887 329.12C181.22 328.911 181.525 329.437 181.195 329.645C178.99 331.039 177.285 333.096 176.325 335.521C175.264 338.218 175.094 341.158 175.278 344.023C175.389 345.755 175.623 347.475 175.859 349.195C175.878 349.273 175.867 349.355 175.827 349.425C175.788 349.494 175.723 349.546 175.646 349.57C175.568 349.591 175.485 349.58 175.415 349.54C175.345 349.5 175.294 349.434 175.272 349.357L175.27 349.357Z"
                fill="#F2F2F2"
              />
              <path
                d="M268.793 141.158C269.343 141.158 269.788 140.713 269.788 140.164C269.788 139.615 269.343 139.169 268.793 139.169C268.244 139.169 267.799 139.615 267.799 140.164C267.799 140.713 268.244 141.158 268.793 141.158Z"
                fill="white"
              />
              <path
                d="M326.944 232.232H208.972C208.874 232.232 208.78 232.193 208.711 232.124C208.641 232.055 208.603 231.961 208.603 231.863L208.782 231.452L326.944 231.494C327.042 231.493 327.136 231.532 327.206 231.601C327.275 231.67 327.314 231.763 327.315 231.861C327.315 231.959 327.277 232.053 327.208 232.123C327.139 232.192 327.045 232.232 326.947 232.232L326.944 232.232Z"
                fill="#3F3D56"
              />
              <path
                d="M231.412 229.649H230.688V231.712H231.412V229.649Z"
                fill="#3F3D56"
              />
              <path
                d="M253.091 217.791H252.367V231.712H253.091V217.791Z"
                fill="#3F3D56"
              />
              <path
                d="M274.814 201.049H274.09V231.712H274.814V201.049Z"
                fill="#3F3D56"
              />
              <path
                d="M296.539 186.749H295.814V231.712H296.539V186.749Z"
                fill="#3F3D56"
              />
              <path
                d="M318.261 219.534H317.537V231.712H318.261V219.534Z"
                fill="#3F3D56"
              />
              <path
                d="M296.221 184.243C297.444 184.243 298.436 183.251 298.436 182.028C298.436 180.804 297.444 179.812 296.221 179.812C294.998 179.812 294.006 180.804 294.006 182.028C294.006 183.251 294.998 184.243 296.221 184.243Z"
                fill="#00B0FF"
              />
              <path
                d="M274.37 197.712C275.594 197.712 276.586 196.72 276.586 195.496C276.586 194.273 275.594 193.281 274.37 193.281C273.147 193.281 272.155 194.273 272.155 195.496C272.155 196.72 273.147 197.712 274.37 197.712Z"
                fill="#00B0FF"
              />
              <path
                d="M317.945 217.669C319.168 217.669 320.16 216.677 320.16 215.454C320.16 214.231 319.168 213.239 317.945 213.239C316.721 213.239 315.729 214.231 315.729 215.454C315.729 216.677 316.721 217.669 317.945 217.669Z"
                fill="#00B0FF"
              />
              <path
                d="M252.15 309.059V282.922C252.15 282.587 252.54 282.315 253.021 282.315H256.907C257.388 282.315 257.778 282.587 257.778 282.922V309.127L252.15 309.059Z"
                fill="#3F3D56"
              />
              <path
                d="M264.985 309.147V289.176C264.985 288.854 265.375 288.593 265.856 288.593H269.742C270.223 288.593 270.613 288.854 270.613 289.176V309.104L264.985 309.147Z"
                fill="#3F3D56"
              />
              <path
                d="M290.656 309.101V298.944C290.622 298.822 291.011 298.717 291.527 298.708H295.413C295.93 298.717 296.318 298.822 296.284 298.944V309.127L290.656 309.101Z"
                fill="#3F3D56"
              />
              <path
                d="M239.314 309.101V298.944C239.314 298.813 239.704 298.708 240.185 298.708H244.071C244.552 298.708 244.942 298.813 244.942 298.944V309.127L239.314 309.101Z"
                fill="#3F3D56"
              />
              <path
                d="M277.821 308.999V259.952C277.821 259.323 278.211 258.813 278.692 258.813H282.578C283.059 258.813 283.449 259.323 283.449 259.952V309.127L277.821 308.999Z"
                fill="#00B0FF"
              />
              <path
                d="M313.033 309.579H225.14C225.047 309.579 224.959 309.542 224.893 309.477C224.828 309.411 224.791 309.323 224.791 309.23C224.791 309.138 224.828 309.049 224.893 308.983C224.959 308.918 225.047 308.881 225.14 308.881H313.033C313.125 308.881 313.214 308.918 313.279 308.983C313.345 309.049 313.381 309.138 313.381 309.23C313.381 309.323 313.345 309.411 313.279 309.477C313.214 309.542 313.125 309.579 313.033 309.579Z"
                fill="#3F3D56"
              />
              <path
                d="M490.859 350.037H125.141C125.016 350.037 124.895 350.001 124.806 349.935C124.717 349.87 124.667 349.781 124.667 349.689C124.667 349.596 124.717 349.507 124.806 349.442C124.895 349.377 125.016 349.34 125.141 349.34H490.859C490.985 349.34 491.106 349.377 491.195 349.442C491.284 349.507 491.334 349.596 491.334 349.689C491.334 349.781 491.284 349.87 491.195 349.935C491.106 350.001 490.985 350.037 490.859 350.037Z"
                fill="#CACACA"
              />
              <path
                d="M231.238 227.818C232.461 227.818 233.453 226.827 233.453 225.603C233.453 224.38 232.461 223.388 231.238 223.388C230.014 223.388 229.022 224.38 229.022 225.603C229.022 226.827 230.014 227.818 231.238 227.818Z"
                fill="#00B0FF"
              />
              <path
                d="M252.583 216.434C253.807 216.434 254.799 215.442 254.799 214.219C254.799 212.996 253.807 212.004 252.583 212.004C251.36 212.004 250.368 212.996 250.368 214.219C250.368 215.442 251.36 216.434 252.583 216.434Z"
                fill="#00B0FF"
              />
              <path
                d="M485.705 375.249L476.503 375.249L472.126 339.758L485.706 339.758L485.705 375.249Z"
                fill="#FFB8B8"
              />
              <path
                d="M488.051 384.169L458.382 384.167V383.792C458.382 380.73 459.599 377.792 461.764 375.627C463.93 373.461 466.867 372.244 469.93 372.244H469.931L488.052 372.245L488.051 384.169Z"
                fill="#2F2E41"
              />
              <path
                d="M526.315 352.628L520.343 359.627L490.503 339.92L499.318 329.589L526.315 352.628Z"
                fill="#FFB8B8"
              />
              <path
                d="M534.624 356.632L515.365 379.201L515.079 378.958C512.75 376.97 511.305 374.138 511.063 371.084C510.822 368.031 511.803 365.007 513.79 362.677L513.791 362.677L525.554 348.892L534.624 356.632Z"
                fill="#2F2E41"
              />
              <path
                d="M420.37 200.709L417.506 227.124L533.291 225.473L482.797 143.196L441.569 141.716L420.37 200.709Z"
                fill="#2F2E41"
              />
              <path
                opacity="0.28"
                d="M420.37 200.709L417.506 227.124L533.291 225.473L482.797 143.196L441.569 141.716L420.37 200.709Z"
                fill="black"
              />
              <path
                d="M443.138 205.243L439.051 229.413V251.018L472.008 261.776C472.008 261.776 468.15 345.691 473.293 351.036L473.167 363.938L487.545 364.591L487.662 355.511L493.757 287.639L497.348 237.808L491.527 200.027L443.138 205.243Z"
                fill="#2F2E41"
              />
              <path
                d="M468.673 226.049L439.051 251.018C439.051 251.018 437.318 296.066 441.72 301.349C445.502 305.887 494.68 345.026 494.68 345.026C494.68 345.026 503.421 353.043 508.319 353.171C513.217 353.299 518.914 343.025 518.914 343.025L507.57 334.406C507.57 334.406 478.182 306.974 469.456 296.066C465.934 291.664 465.934 291.224 465.934 291.224L467.137 272.916L479.243 238.938L468.673 226.049Z"
                fill="#2F2E41"
              />
              <path
                d="M437.224 106.449L424.453 105.269L412.868 107.2L388.339 107.207L386.249 124.986L408.634 129.995L414.089 127.322L436.829 135.985L437.224 106.449Z"
                fill="#2F2E41"
              />
              <path
                d="M452.478 106.394C452.478 106.394 479.582 103.854 485.745 108.697C491.909 113.54 505.116 209.514 505.116 209.514L452.478 212.485L443.041 205.992L445.72 158.078L452.478 106.394Z"
                fill="#CCCCCC"
              />
              <path
                d="M460.75 105.796L430.852 106.452L402.978 232.407L424.99 237.25L460.75 105.796Z"
                fill="#2F2E41"
              />
              <path
                d="M482.004 104.731L505.555 112.102L504.217 163.853L533.291 225.725L499.113 229.325L472.097 162.515L482.004 104.731Z"
                fill="#2F2E41"
              />
              <path
                d="M520.84 232.01C521.665 231.283 522.321 230.384 522.762 229.376C523.203 228.368 523.417 227.276 523.39 226.176C523.363 225.076 523.095 223.996 522.605 223.011C522.115 222.026 521.415 221.161 520.555 220.476L525.292 203.947L515.95 198.618L509.587 222.053C508.532 223.575 508.072 225.432 508.294 227.27C508.516 229.109 509.404 230.802 510.791 232.029C512.178 233.257 513.967 233.932 515.819 233.929C517.671 233.925 519.457 233.242 520.84 232.01Z"
                fill="#FFB8B8"
              />
              <path
                d="M491.908 113.54L505.844 112.331C505.844 112.331 518.354 125.415 521.2 135.547C524.046 145.678 527.128 177.376 527.128 177.376L525.843 223.747L509.553 212.685L508.461 172.8L491.908 113.54Z"
                fill="#2F2E41"
              />
              <path
                d="M488.547 90.2324C493.78 80.6596 490.261 68.6571 480.689 63.4242C471.116 58.1912 459.113 61.7093 453.88 71.2821C448.647 80.8549 452.166 92.8574 461.738 98.0904C471.311 103.323 483.314 99.8052 488.547 90.2324Z"
                fill="#FFB8B8"
              />
              <path
                d="M469.011 72.5104C466.42 71.9116 463.729 72.5752 461.104 73.0054C458.479 73.4356 455.586 73.5774 453.366 72.1128C451.726 71.0311 450.718 69.2417 449.771 67.5204C449.376 66.9057 449.113 66.2157 448.998 65.4941C448.886 64.221 449.696 63.0596 450.556 62.1143C454.55 57.7236 460.387 55.3205 466.274 54.5572C471.128 53.8337 476.088 54.4393 480.626 56.3098C485.094 58.2696 488.936 61.8587 490.692 66.4108C491.502 68.7406 492.007 71.1651 492.196 73.6242C492.461 75.4334 492.495 77.2691 492.297 79.087C492.061 80.4347 491.706 81.759 491.239 83.0448L488.328 91.8321C488.119 92.6625 487.728 93.4361 487.184 94.0972C486.904 94.421 486.527 94.6455 486.109 94.737C485.692 94.8286 485.255 94.7823 484.866 94.6051C485.099 93.6506 485.134 92.6587 484.97 91.69C484.879 91.2073 484.646 90.7629 484.3 90.414C483.954 90.0652 483.511 89.8279 483.029 89.7328C481.957 89.6189 481.04 90.4504 480.023 90.8085C479.557 90.9466 479.069 90.9916 478.586 90.9409C478.103 90.8902 477.634 90.7449 477.207 90.5132C476.781 90.2815 476.404 89.9681 476.098 89.5906C475.792 89.2132 475.564 88.7793 475.426 88.3136C475.398 88.2197 475.374 88.1249 475.353 88.029C475.193 87.0244 475.462 85.9489 475.082 85.0055C474.635 83.9001 473.452 83.321 472.564 82.5267C471.753 81.7783 471.172 80.8139 470.89 79.7468C470.609 78.6798 470.637 77.5546 470.973 76.5033C471.211 75.772 471.883 75.4395 471.749 74.5994C471.572 73.4973 469.947 72.7267 469.011 72.5104Z"
                fill="#2F2E41"
              />
              <path d="M249.393 156.013H0V0H249.393V156.013Z" fill="white" />
              <path
                d="M249.393 156.013H0V0H249.393V156.013ZM1.13878 154.874H248.254V1.13878H1.13878V154.874Z"
                fill="#3F3D56"
              />
              <path
                d="M218.93 372.097H76.583V216.084H218.93V372.097Z"
                fill="white"
              />
              <path
                d="M218.93 372.097H76.583V216.084H218.93V372.097ZM77.7218 370.958H217.792V217.223H77.7218V370.958Z"
                fill="#3F3D56"
              />
              <path
                d="M199.571 357.361H169.963V358.562H199.571V357.361Z"
                fill="#3F3D56"
              />
              <path
                d="M199.571 360.962H169.963V362.163H199.571V360.962Z"
                fill="#3F3D56"
              />
              <path
                d="M199.571 364.563H169.963V365.764H199.571V364.563Z"
                fill="#3F3D56"
              />
              <path
                d="M147.757 243.984V256.51C155.189 256.51 162.455 258.714 168.635 262.844C174.815 266.973 179.632 272.842 182.476 279.709C185.32 286.576 186.064 294.132 184.614 301.421C183.164 308.711 179.585 315.407 174.33 320.663L183.187 329.52C190.195 322.513 194.967 313.585 196.9 303.865C198.834 294.145 197.841 284.071 194.049 274.915C190.257 265.759 183.834 257.934 175.594 252.428C167.354 246.922 157.667 243.984 147.757 243.984Z"
                fill="#E6E6E6"
              />
              <path
                d="M183.187 329.52L174.329 320.663C167.905 327.089 159.368 330.969 150.302 331.584C141.236 332.198 132.254 329.506 125.02 324.006L117.438 333.982C127.085 341.314 139.061 344.902 151.15 344.081C163.238 343.261 174.62 338.088 183.187 329.52Z"
                fill="#575A89"
              />
              <path
                d="M110.177 294.09C110.177 289.155 111.149 284.268 113.038 279.709C114.926 275.149 117.694 271.007 121.184 267.517C124.673 264.027 128.816 261.259 133.376 259.371C137.935 257.482 142.822 256.51 147.757 256.51V243.984C137.268 243.984 127.043 247.275 118.524 253.395C110.005 259.514 103.621 268.153 100.272 278.093C96.9237 288.034 96.7791 298.774 99.8588 308.801C102.939 318.828 109.087 327.636 117.439 333.982L125.02 324.006C120.404 320.505 116.661 315.981 114.086 310.791C111.511 305.6 110.173 299.884 110.177 294.09Z"
                fill="#00B2FF"
              />
              <path
                d="M429.604 275.3H287.257V119.287H429.604V275.3Z"
                fill="white"
              />
              <path
                d="M429.604 275.3H287.257V119.287H429.604V275.3ZM288.396 274.161H428.465V120.426H288.396V274.161Z"
                fill="#3F3D56"
              />
              <path
                d="M333.377 214.66H307.755V255.656H333.377V214.66Z"
                fill="#575A89"
              />
              <path
                d="M370.388 186.76H344.766V255.656H370.388V186.76Z"
                fill="#E6E6E6"
              />
              <path
                d="M407.398 154.305H381.775V255.656H407.398V154.305Z"
                fill="#00B2FF"
              />
              <path
                d="M415.939 256.795H300.923V137.792H302.061V255.656H415.939V256.795Z"
                fill="#3F3D56"
              />
              <path
                d="M388.209 123.441C392.541 123.441 396.052 119.93 396.052 115.598C396.052 111.267 392.541 107.756 388.209 107.756C383.878 107.756 380.367 111.267 380.367 115.598C380.367 119.93 383.878 123.441 388.209 123.441Z"
                fill="#FFB8B8"
              />
              <path
                d="M549.346 384.926H427.137C426.964 384.926 426.797 384.857 426.675 384.735C426.552 384.612 426.483 384.446 426.483 384.273C426.483 384.099 426.552 383.933 426.675 383.81C426.797 383.688 426.964 383.619 427.137 383.619H549.346C549.519 383.619 549.686 383.688 549.808 383.81C549.931 383.933 550 384.099 550 384.273C550 384.446 549.931 384.612 549.808 384.735C549.686 384.857 549.519 384.926 549.346 384.926Z"
                fill="#CCCCCC"
              />
              <path
                d="M214.758 123.385H34.635C34.4855 123.385 34.3421 123.325 34.2364 123.219C34.1307 123.114 34.0713 122.97 34.0713 122.821V36.4878C34.0713 36.3383 34.1307 36.1949 34.2364 36.0892C34.3421 35.9835 34.4855 35.9241 34.635 35.9241C34.7845 35.9241 34.9279 35.9835 35.0336 36.0892C35.1393 36.1949 35.1987 36.3383 35.1987 36.4878V122.257H214.758C214.832 122.257 214.906 122.271 214.975 122.3C215.043 122.328 215.106 122.369 215.158 122.422C215.211 122.474 215.252 122.536 215.281 122.605C215.309 122.673 215.324 122.747 215.324 122.821C215.324 122.895 215.309 122.969 215.281 123.037C215.252 123.106 215.211 123.168 215.158 123.22C215.106 123.273 215.043 123.314 214.975 123.342C214.906 123.37 214.832 123.385 214.758 123.385Z"
                fill="#3F3D56"
              />
              <path
                d="M73.1188 117.184H56.7359C56.2922 117.183 55.8669 117.007 55.5532 116.693C55.2395 116.38 55.063 115.954 55.0625 115.511V92.9266C55.063 92.483 55.2395 92.0577 55.5532 91.744C55.8669 91.4304 56.2922 91.2539 56.7359 91.2534H73.1188C73.5624 91.2539 73.9877 91.4304 74.3014 91.744C74.6151 92.0577 74.7916 92.483 74.7921 92.9266V115.511C74.7916 115.954 74.6151 116.38 74.3014 116.693C73.9877 117.007 73.5624 117.183 73.1188 117.184Z"
                fill="#00B2FF"
              />
              <path
                d="M102.996 117.184H86.6128C86.1692 117.183 85.7439 117.007 85.4302 116.693C85.1165 116.379 84.94 115.954 84.9395 115.511V71.5059C84.94 71.0622 85.1165 70.6369 85.4302 70.3233C85.7439 70.0096 86.1692 69.8331 86.6128 69.8326H102.996C103.439 69.8331 103.865 70.0096 104.178 70.3233C104.492 70.6369 104.669 71.0622 104.669 71.5059V115.511C104.669 115.954 104.492 116.379 104.178 116.693C103.865 117.007 103.439 117.183 102.996 117.184Z"
                fill="#00B2FF"
              />
              <path
                d="M132.872 117.184H116.489C116.045 117.183 115.62 117.007 115.306 116.693C114.992 116.38 114.816 115.954 114.815 115.511V92.9266C114.816 92.483 114.992 92.0577 115.306 91.744C115.62 91.4304 116.045 91.2539 116.489 91.2534H132.872C133.315 91.2539 133.741 91.4304 134.054 91.744C134.368 92.0577 134.545 92.483 134.545 92.9266V115.511C134.545 115.954 134.368 116.38 134.054 116.693C133.741 117.007 133.315 117.183 132.872 117.184Z"
                fill="#00B2FF"
              />
              <path
                d="M162.748 117.184H146.365C145.931 117.193 145.512 117.03 145.198 116.731C144.884 116.431 144.702 116.02 144.691 115.586V62.9745C144.702 62.541 144.884 62.1295 145.198 61.8301C145.512 61.5306 145.931 61.3678 146.365 61.3771H162.748C163.181 61.3678 163.601 61.5306 163.914 61.8301C164.228 62.1295 164.41 62.541 164.421 62.9745V115.586C164.41 116.02 164.228 116.431 163.914 116.731C163.601 117.03 163.181 117.193 162.748 117.184Z"
                fill="#00B2FF"
              />
              <path
                d="M192.625 117.184H176.242C175.798 117.183 175.373 117.007 175.059 116.693C174.745 116.379 174.569 115.954 174.568 115.511V47.8303C174.569 47.3867 174.745 46.9614 175.059 46.6477C175.373 46.334 175.798 46.1576 176.242 46.1571H192.625C193.068 46.1576 193.494 46.334 193.807 46.6477C194.121 46.9614 194.297 47.3867 194.298 47.8303V115.511C194.297 115.954 194.121 116.379 193.807 116.693C193.494 117.007 193.068 117.183 192.625 117.184Z"
                fill="#00B2FF"
              />
              <path
                d="M64.9281 84.4891C66.7961 84.4891 68.3103 82.9748 68.3103 81.1068C68.3103 79.2389 66.7961 77.7246 64.9281 77.7246C63.0602 77.7246 61.5459 79.2389 61.5459 81.1068C61.5459 82.9748 63.0602 84.4891 64.9281 84.4891Z"
                fill="#3F3D56"
              />
              <path
                d="M94.8041 62.5046C96.672 62.5046 98.1863 60.9903 98.1863 59.1223C98.1863 57.2544 96.672 55.7401 94.8041 55.7401C92.9361 55.7401 91.4219 57.2544 91.4219 59.1223C91.4219 60.9903 92.9361 62.5046 94.8041 62.5046Z"
                fill="#3F3D56"
              />
              <path
                d="M124.68 84.4891C126.548 84.4891 128.062 82.9748 128.062 81.1068C128.062 79.2389 126.548 77.7246 124.68 77.7246C122.812 77.7246 121.298 79.2389 121.298 81.1068C121.298 82.9748 122.812 84.4891 124.68 84.4891Z"
                fill="#3F3D56"
              />
              <path
                d="M154.557 51.7942C156.425 51.7942 157.939 50.28 157.939 48.412C157.939 46.5441 156.425 45.0298 154.557 45.0298C152.689 45.0298 151.175 46.5441 151.175 48.412C151.175 50.28 152.689 51.7942 154.557 51.7942Z"
                fill="#3F3D56"
              />
              <path
                d="M184.433 39.3927C186.301 39.3927 187.815 37.8785 187.815 36.0105C187.815 34.1426 186.301 32.6283 184.433 32.6283C182.565 32.6283 181.051 34.1426 181.051 36.0105C181.051 37.8785 182.565 39.3927 184.433 39.3927Z"
                fill="#3F3D56"
              />
              <path
                d="M124.751 81.8644L94.8042 59.4335L65.2656 81.5579L64.5898 80.6554L94.8042 58.0245L124.609 80.3489L154.227 47.9374L154.346 47.889L184.222 35.8511L184.644 36.8974L154.886 48.8869L124.751 81.8644Z"
                fill="#3F3D56"
              />
            </g>
            <defs>
              <clipPath id="clip0_4_98">
                <rect width="550" height="384.926" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="hero-text">
          <h3 class="inner" style="--delay: 0.1s">
            Advanced Statistics Software For <b>Data Analysis</b>
          </h3>
          <h2 class="slide inner" style="--delay: 0.3s">
            Comprehensive data analysis software with advanced statistical
            tools, flexible integrations, and modern, intuitive visualization.
          </h2>
          <div class="cta inner" style="--delay: 0.5s">
            <button class="primary btn">
              <a href="#sign-up">Pre-order Now</a>
            </button>
          </div>
        </div>
      </div>

      <div
        :class="[
          activeslide === 5
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div class="hero-text">
          <h3 class="inner" style="--delay: 0.1s">
            <b>Bioequivalence Software</b> With Protocols Library & Data Tools
          </h3>
          <h2 class="slide inner" style="--delay: 0.3s">
            Streamline bioequivalence studies with ready-to-use protocols,
            digital data tools, automated workflows, and regulatory compliance.
          </h2>
          <div class="cta inner" style="--delay: 0.5s">
            <button class="primary btn">
              <a href="#sign-up">Pre-order Now</a>
            </button>
          </div>
        </div>

        <div
          class="hero-image right"
          data-aos="fade-left"
          data-aos-duration="2000"
        >
          <svg
            width="560"
            height="379"
            viewBox="0 0 560 379"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4_146)">
              <path
                d="M171.401 175.623H99.3164V256.226H171.401V175.623Z"
                fill="#CCCCCC"
              />
              <path
                d="M62.6195 377.459H25.9221L21.9902 346.004H66.5514L62.6195 377.459Z"
                fill="#E6E6E6"
              />
              <path
                d="M136.309 354.675L135.071 371.605C135.015 372.372 135.123 373.141 135.389 373.862C135.655 374.583 136.072 375.239 136.611 375.786C137.151 376.332 137.802 376.757 138.52 377.032C139.237 377.306 140.005 377.425 140.772 377.378L149.468 376.851C149.871 376.827 150.264 376.714 150.618 376.521C150.972 376.327 151.28 376.058 151.518 375.733C151.757 375.407 151.921 375.033 151.999 374.637C152.077 374.241 152.066 373.832 151.968 373.441L147.141 354.134L136.309 354.675Z"
                fill="#E6E6E6"
              />
              <path
                d="M209.046 364.687C219.28 367.081 226.591 370.484 231.394 375.089C233.104 376.717 235.342 377.676 237.7 377.793C240.713 377.951 243.175 377.613 245.026 376.787C245.5 376.578 245.91 376.245 246.213 375.825C246.515 375.404 246.7 374.91 246.747 374.394C246.803 373.87 246.718 373.34 246.5 372.86C246.282 372.38 245.94 371.967 245.509 371.664L221.237 354.393L210.927 358.518L208.522 360.923C208.261 361.183 208.065 361.5 207.948 361.85C207.831 362.199 207.796 362.57 207.847 362.935C207.898 363.3 208.033 363.648 208.241 363.952C208.449 364.256 208.724 364.507 209.046 364.687Z"
                fill="#E6E6E6"
              />
              <path
                d="M177.55 88.2667L108.17 87.6243C108.344 77.519 110.696 67.5959 115.835 58.7161C119.21 52.8842 119.137 46.5373 118.324 41.1902C117.069 32.9385 119.988 24.4959 126.474 19.2431C131.431 15.2219 137.687 13.1519 144.064 13.423L145.411 13.4792C149.8 13.6615 154.072 14.9434 157.836 17.2071C161.599 19.4708 164.734 22.6437 166.952 26.4346C169.206 30.4815 170.115 35.1403 169.548 39.7378C169.108 44.0637 170.16 48.4337 172.622 52.8453C176.868 62.5324 177.788 74.9284 177.55 88.2667Z"
                fill="#2F2E41"
              />
              <path
                d="M223.968 355.294L210.352 358.846L144.045 214.392L148.189 355.294H134.573C120.023 289.003 93.7531 212.497 105.564 188.343L176.014 184.199L223.968 355.294Z"
                fill="#00B2FF"
              />
              <path
                d="M143.453 64.0181C153.589 64.0181 161.806 55.8013 161.806 45.6654C161.806 35.5294 153.589 27.3126 143.453 27.3126C133.317 27.3126 125.101 35.5294 125.101 45.6654C125.101 55.8013 133.317 64.0181 143.453 64.0181Z"
                fill="#FFB9B9"
              />
              <path
                d="M159.438 79.4107L129.245 77.6347C132.204 70.8432 133.386 64.3033 132.205 58.0979H154.702C154.651 62.8624 157.022 71.1041 159.438 79.4107Z"
                fill="#FFB9B9"
              />
              <path
                d="M178.382 189.527L112.076 194.264L118.884 76.7467L130.429 73.4904L143.453 76.4505L156.477 69.938L164.766 72.8987L178.382 189.527Z"
                fill="#00B2FF"
              />
              <path
                d="M123.325 274.187L78.0352 263.826C91.5022 219.168 115.764 117.003 107.932 80.5948L131.613 69.9384L123.325 274.187Z"
                fill="#E6E6E6"
              />
              <path
                d="M101.42 145.125L84.251 134.469L98.8928 91.5858C100.526 87.1608 103.654 83.4455 107.736 81.0822L112.668 78.2267L109.708 121.444L101.42 145.125Z"
                fill="#E6E6E6"
              />
              <path
                d="M217.752 264.418C203.458 272.688 167.726 277.298 152.037 271.523C150.883 231.173 148.619 117.04 155.886 68.7543L181.935 79.4107L179.567 111.38C167.113 138.728 203.275 233.981 217.752 264.418Z"
                fill="#E6E6E6"
              />
              <path
                d="M215.68 139.797L199.695 134.469L178.383 110.196L181.935 79.4105L217.456 129.141L215.68 139.797Z"
                fill="#E6E6E6"
              />
              <path
                d="M165.584 162.841C165.846 163.989 166.552 164.986 167.547 165.614C168.543 166.242 169.747 166.449 170.896 166.191L184.464 163.118L182.503 154.457L168.934 157.529C167.786 157.79 166.788 158.495 166.159 159.491C165.531 160.487 165.324 161.692 165.584 162.841Z"
                fill="#FFB9B9"
              />
              <path
                d="M159.438 40.9291C149.244 36.7374 139.176 36.4341 129.245 40.3371L125.101 25.5365H162.99L159.438 40.9291Z"
                fill="#2F2E41"
              />
              <path
                d="M177.791 152.822L185.487 167.03C198.432 163.42 209.651 152.038 220.417 138.613L217.457 129.141L199.104 133.877L177.791 152.822Z"
                fill="#E6E6E6"
              />
              <path
                d="M172.167 123.516H169.798C169.798 90.0232 162.902 66.6822 156.182 66.6822L155.59 64.3141C161.617 64.3141 165.459 74.0284 167.621 82.178C170.552 93.2261 172.167 107.907 172.167 123.516Z"
                fill="#3F3D56"
              />
              <path
                d="M117.7 115.228H115.332C115.332 84.5536 122.276 65.4982 132.501 65.4982L131.909 67.8663C124.836 67.8663 117.7 82.5111 117.7 115.228Z"
                fill="#3F3D56"
              />
              <path
                d="M170.983 130.029C174.252 130.029 176.903 127.378 176.903 124.108C176.903 120.839 174.252 118.188 170.983 118.188C167.713 118.188 165.062 120.839 165.062 124.108C165.062 127.378 167.713 130.029 170.983 130.029Z"
                fill="#3F3D56"
              />
              <path
                d="M108.228 129.437H105.86C105.86 120.949 110.641 114.044 116.517 114.044V116.412C111.947 116.412 108.228 122.255 108.228 129.437Z"
                fill="#3F3D56"
              />
              <path
                d="M127.173 129.437H124.805C124.805 122.255 121.087 116.412 116.517 116.412V114.044C122.393 114.044 127.173 120.949 127.173 129.437Z"
                fill="#3F3D56"
              />
              <path
                d="M125.989 132.397C127.297 132.397 128.357 131.337 128.357 130.029C128.357 128.721 127.297 127.661 125.989 127.661C124.681 127.661 123.621 128.721 123.621 130.029C123.621 131.337 124.681 132.397 125.989 132.397Z"
                fill="#3F3D56"
              />
              <path
                d="M107.044 132.397C108.352 132.397 109.412 131.337 109.412 130.029C109.412 128.721 108.352 127.661 107.044 127.661C105.736 127.661 104.676 128.721 104.676 130.029C104.676 131.337 105.736 132.397 107.044 132.397Z"
                fill="#3F3D56"
              />
              <path
                d="M77.4424 108.253L92.2177 110.891L125.988 158.91L108.047 154.688L77.4424 108.253Z"
                fill="#00B2FF"
              />
              <path
                d="M74.8218 107.665C74.5966 107.668 74.3765 107.732 74.1845 107.85C73.9924 107.967 73.8355 108.134 73.7301 108.333C73.6247 108.532 73.5747 108.756 73.5854 108.981C73.596 109.206 73.6669 109.424 73.7906 109.612L105.358 157.507C105.534 157.775 105.806 157.965 106.118 158.038L120.805 161.494C121.053 161.552 121.312 161.534 121.549 161.441C121.786 161.348 121.99 161.186 122.132 160.975C122.275 160.764 122.35 160.515 122.347 160.261C122.345 160.007 122.265 159.759 122.119 159.551L87.4601 110.27C87.3661 110.136 87.2465 110.022 87.1083 109.934C86.9701 109.845 86.8158 109.786 86.6544 109.757L75.0585 107.686C74.9804 107.672 74.9011 107.665 74.8218 107.665Z"
                fill="#3F3D56"
              />
              <path
                d="M94.5137 141.909L95.391 150.746L109.235 149.372C110.407 149.256 111.485 148.679 112.231 147.768C112.978 146.857 113.332 145.687 113.215 144.515C113.099 143.343 112.522 142.266 111.611 141.519C110.7 140.773 109.53 140.419 108.358 140.535L94.5137 141.909Z"
                fill="#FFB9B9"
              />
              <path
                d="M82.4756 140.886C82.4957 143.899 83.7059 146.782 85.8425 148.907C87.9791 151.032 90.8689 152.226 93.8822 152.23H96.1586L97.8159 138.419L84.0938 133.479L82.4756 140.886Z"
                fill="#E6E6E6"
              />
              <path d="M560 0H290.012V142.202H560V0Z" fill="#E6E6E6" />
              <path
                d="M297.876 134.339H552.136V7.86377H297.876V134.339Z"
                fill="white"
              />
              <path
                d="M407.968 26.2124H317.535V116.645H407.968V26.2124Z"
                fill="#3F3D56"
              />
              <path
                d="M386.343 67.497C387.791 67.497 388.964 66.3234 388.964 64.8758C388.964 63.4281 387.791 62.2545 386.343 62.2545C384.895 62.2545 383.722 63.4281 383.722 64.8758C383.722 66.3234 384.895 67.497 386.343 67.497Z"
                fill="#00B2FF"
              />
              <path
                d="M376.513 58.3227C377.961 58.3227 379.134 57.1491 379.134 55.7014C379.134 54.2538 377.961 53.0802 376.513 53.0802C375.065 53.0802 373.892 54.2538 373.892 55.7014C373.892 57.1491 375.065 58.3227 376.513 58.3227Z"
                fill="#00B2FF"
              />
              <path
                d="M375.202 64.8757C374.238 64.8759 373.292 65.1438 372.471 65.6497C371.748 64.5619 370.898 63.5641 369.939 62.6773C369.95 62.5374 369.96 62.3973 369.96 62.2545C369.961 61.2259 369.659 60.2198 369.091 59.3618C368.524 58.5037 367.717 57.8316 366.77 57.4293C365.824 57.027 364.779 56.9123 363.768 57.0995C362.757 57.2867 361.823 57.7675 361.083 58.482C359.679 58.2827 358.255 58.2703 356.848 58.445C356.849 58.4039 356.854 58.364 356.854 58.3227C356.855 57.4452 356.636 56.5814 356.216 55.8106C355.797 55.0398 355.191 54.3866 354.453 53.9109C353.716 53.4352 352.871 53.1521 351.996 53.0877C351.121 53.0233 350.244 53.1796 349.445 53.5423C348.646 53.905 347.95 54.4624 347.423 55.1635C346.895 55.8646 346.552 56.687 346.424 57.5552C346.297 58.4234 346.39 59.3096 346.694 60.1328C346.998 60.9559 347.504 61.6895 348.165 62.2664C347.287 63.0182 346.491 63.8602 345.79 64.7786C345.143 64.2401 344.375 63.8654 343.553 63.6862C342.73 63.5069 341.877 63.5284 341.064 63.7488C340.252 63.9692 339.504 64.382 338.885 64.9523C338.266 65.5227 337.793 66.2337 337.507 67.0254C337.221 67.817 337.129 68.666 337.24 69.5005C337.352 70.3349 337.662 71.1303 338.146 71.8194C338.629 72.5085 339.272 73.0709 340.019 73.4592C340.766 73.8475 341.595 74.0502 342.437 74.0501L342.454 74.0493C342.445 74.2672 342.437 74.4854 342.437 74.7054C342.437 76.0245 342.596 77.3387 342.911 78.6196C341.353 79.2059 339.97 80.1784 338.89 81.4459C337.811 82.7134 337.072 84.2343 336.741 85.8659C336.411 87.4975 336.501 89.1863 337.002 90.7737C337.503 92.3612 338.399 93.7953 339.606 94.9415C340.814 96.0877 342.292 96.9083 343.904 97.3264C345.515 97.7445 347.206 97.7463 348.819 97.3317C350.431 96.9171 351.911 96.0997 353.121 94.9562C354.331 93.8126 355.23 92.3805 355.735 90.7941C359.381 91.495 363.158 90.9347 366.444 89.2054C366.78 89.9954 367.304 90.6909 367.971 91.2309C368.638 91.771 369.428 92.1389 370.27 92.3026C371.113 92.4663 371.982 92.4206 372.803 92.1696C373.624 91.9187 374.371 91.4701 374.977 90.8632C375.584 90.2563 376.033 89.5097 376.284 88.689C376.535 87.8682 376.581 86.9984 376.417 86.1559C376.253 85.3134 375.885 84.5239 375.345 83.8568C374.805 83.1898 374.11 82.6654 373.32 82.3299C374.455 80.1753 375.093 77.7935 375.186 75.3599L375.202 75.3608C376.593 75.3608 377.926 74.8084 378.909 73.8253C379.893 72.8421 380.445 71.5087 380.445 70.1183C380.445 68.7279 379.893 67.3944 378.909 66.4113C377.926 65.4281 376.593 64.8757 375.202 64.8757Z"
                fill="#00B2FF"
              />
              <path
                d="M373.892 24.2465H347.68V28.1783H373.892V24.2465Z"
                fill="#E6E6E6"
              />
              <path
                d="M523.303 26.2124H432.87V116.645H523.303V26.2124Z"
                fill="#3F3D56"
              />
              <path
                d="M495.256 87.5496C495.907 87.5496 496.435 87.0214 496.435 86.37C496.435 85.7185 495.907 85.1904 495.256 85.1904C494.604 85.1904 494.076 85.7185 494.076 86.37C494.076 87.0214 494.604 87.5496 495.256 87.5496Z"
                fill="#00B2FF"
              />
              <path
                d="M490.832 83.421C491.483 83.421 492.011 82.8929 492.011 82.2415C492.011 81.59 491.483 81.0619 490.832 81.0619C490.18 81.0619 489.652 81.59 489.652 82.2415C489.652 82.8929 490.18 83.421 490.832 83.421Z"
                fill="#00B2FF"
              />
              <path
                d="M490.242 86.3699C489.808 86.37 489.383 86.4906 489.013 86.7182C488.688 86.2287 488.305 85.7797 487.873 85.3806C487.878 85.3177 487.883 85.2546 487.883 85.1904C487.883 84.7275 487.747 84.2747 487.492 83.8886C487.237 83.5025 486.874 83.2001 486.448 83.019C486.022 82.838 485.552 82.7864 485.097 82.8706C484.642 82.9548 484.221 83.1712 483.888 83.4927C483.256 83.403 482.616 83.3975 481.982 83.4761C481.983 83.4576 481.985 83.4396 481.985 83.421C481.986 83.0262 481.887 82.6375 481.698 82.2906C481.51 81.9438 481.237 81.6498 480.905 81.4357C480.573 81.2217 480.193 81.0943 479.799 81.0653C479.405 81.0363 479.011 81.1067 478.651 81.2699C478.292 81.4331 477.979 81.6839 477.741 81.9994C477.504 82.3149 477.349 82.685 477.292 83.0757C477.235 83.4663 477.276 83.8652 477.413 84.2356C477.55 84.606 477.778 84.9361 478.075 85.1957C477.68 85.534 477.322 85.9129 477.006 86.3262C476.715 86.0839 476.37 85.9153 476 85.8346C475.63 85.7539 475.246 85.7636 474.88 85.8628C474.514 85.962 474.178 86.1477 473.899 86.4044C473.621 86.661 473.408 86.981 473.279 87.3373C473.15 87.6935 473.109 88.0755 473.159 88.451C473.209 88.8266 473.349 89.1845 473.567 89.4945C473.784 89.8046 474.073 90.0577 474.409 90.2325C474.746 90.4072 475.119 90.4984 475.498 90.4984L475.505 90.498C475.501 90.5961 475.498 90.6942 475.498 90.7933C475.498 91.3868 475.569 91.9782 475.711 92.5546C475.01 92.8185 474.387 93.2561 473.902 93.8265C473.416 94.3968 473.083 95.0813 472.935 95.8155C472.786 96.5497 472.826 97.3096 473.052 98.024C473.277 98.7384 473.681 99.3837 474.224 99.8995C474.767 100.415 475.433 100.785 476.158 100.973C476.883 101.161 477.644 101.162 478.369 100.975C479.095 100.789 479.761 100.421 480.305 99.9061C480.85 99.3915 481.255 98.747 481.482 98.0332C483.123 98.3486 484.822 98.0964 486.301 97.3183C486.452 97.6737 486.688 97.9867 486.988 98.2297C487.288 98.4727 487.643 98.6383 488.023 98.712C488.402 98.7856 488.793 98.7651 489.163 98.6522C489.532 98.5392 489.868 98.3373 490.141 98.0642C490.414 97.7911 490.616 97.4552 490.729 97.0859C490.842 96.7165 490.862 96.3251 490.789 95.946C490.715 95.5668 490.549 95.2116 490.306 94.9114C490.063 94.6112 489.75 94.3753 489.395 94.2243C489.906 93.2547 490.193 92.1829 490.235 91.0878L490.242 91.0882C490.868 91.0882 491.468 90.8396 491.91 90.3972C492.353 89.9548 492.601 89.3547 492.601 88.729C492.601 88.1034 492.353 87.5033 491.91 87.0609C491.468 86.6185 490.868 86.3699 490.242 86.3699Z"
                fill="#00B2FF"
              />
              <path
                d="M504.51 65.1653C505.161 65.1653 505.689 64.6372 505.689 63.9857C505.689 63.3343 505.161 62.8062 504.51 62.8062C503.858 62.8062 503.33 63.3343 503.33 63.9857C503.33 64.6372 503.858 65.1653 504.51 65.1653Z"
                fill="#00B2FF"
              />
              <path
                d="M507.284 59.7883C507.935 59.7883 508.464 59.2602 508.464 58.6088C508.464 57.9573 507.935 57.4292 507.284 57.4292C506.633 57.4292 506.104 57.9573 506.104 58.6088C506.104 59.2602 506.633 59.7883 507.284 59.7883Z"
                fill="#00B2FF"
              />
              <path
                d="M503.15 59.1603C503.033 58.7425 502.801 58.3656 502.482 58.0716C502.865 57.6256 503.193 57.1357 503.46 56.612C503.522 56.5998 503.584 56.5871 503.646 56.5697C504.092 56.4446 504.491 56.191 504.793 55.8406C505.096 55.4903 505.288 55.0586 505.347 54.5995C505.406 54.1404 505.328 53.6741 505.124 53.2588C504.919 52.8435 504.597 52.4977 504.197 52.2643C504.112 51.6319 503.944 51.0136 503.697 50.4254C503.715 50.4208 503.733 50.4182 503.751 50.4131C504.131 50.3066 504.478 50.1063 504.761 49.8306C505.044 49.5549 505.253 49.2127 505.369 48.8353C505.485 48.4579 505.504 48.0573 505.425 47.6704C505.347 47.2835 505.172 46.9226 504.917 46.6207C504.663 46.3188 504.337 46.0857 503.968 45.9427C503.6 45.7996 503.202 45.7512 502.811 45.802C502.419 45.8527 502.047 46.0009 501.727 46.2331C501.408 46.4652 501.152 46.7738 500.982 47.1305C500.55 46.8421 500.088 46.6 499.604 46.4082C499.759 46.0622 499.828 45.6842 499.805 45.306C499.782 44.9279 499.669 44.5608 499.474 44.2357C499.28 43.9107 499.01 43.6373 498.687 43.4387C498.364 43.24 497.999 43.122 497.621 43.0946C497.243 43.0671 496.864 43.1311 496.516 43.2811C496.168 43.431 495.862 43.6626 495.622 43.9561C495.383 44.2496 495.218 44.5965 495.141 44.9674C495.063 45.3383 495.077 45.7223 495.18 46.0869L495.182 46.094C495.086 46.1169 494.991 46.14 494.896 46.1669C494.324 46.3279 493.775 46.5571 493.258 46.8497C492.814 46.2464 492.224 45.7657 491.543 45.4529C490.863 45.14 490.114 45.0052 489.367 45.0612C488.62 45.1171 487.899 45.3619 487.273 45.7726C486.646 46.1834 486.134 46.7465 485.785 47.4093C485.436 48.072 485.261 48.8126 485.276 49.5616C485.292 50.3106 485.497 51.0433 485.874 51.6911C486.25 52.3389 486.784 52.8804 487.427 53.2649C488.07 53.6495 488.8 53.8643 489.549 53.8894C489.69 55.5544 490.394 57.1219 491.544 58.3344C491.242 58.5761 491.005 58.888 490.852 59.2428C490.7 59.5977 490.637 59.9845 490.669 60.3694C490.701 60.7543 490.826 61.1255 491.035 61.4504C491.244 61.7753 491.529 62.0439 491.866 62.2328C492.203 62.4216 492.581 62.5249 492.968 62.5335C493.354 62.5421 493.736 62.4557 494.081 62.2821C494.426 62.1084 494.723 61.8527 494.946 61.5374C495.169 61.2221 495.311 60.8569 495.36 60.4738C496.432 60.7027 497.542 60.6884 498.607 60.4319L498.609 60.4392C498.693 60.7376 498.834 61.0166 499.026 61.2602C499.218 61.5038 499.455 61.7072 499.726 61.8589C499.996 62.0105 500.294 62.1074 500.601 62.144C500.909 62.1806 501.221 62.1562 501.519 62.0722C501.818 61.9882 502.097 61.8462 502.34 61.6544C502.584 61.4625 502.787 61.2246 502.938 60.9541C503.09 60.6837 503.186 60.3861 503.223 60.0783C503.259 59.7705 503.235 59.4585 503.15 59.1603Z"
                fill="#00B2FF"
              />
              <path
                d="M458.823 49.1362C459.475 49.1362 460.003 48.6081 460.003 47.9567C460.003 47.3052 459.475 46.7771 458.823 46.7771C458.172 46.7771 457.644 47.3052 457.644 47.9567C457.644 48.6081 458.172 49.1362 458.823 49.1362Z"
                fill="#00B2FF"
              />
              <path
                d="M452.792 49.6194C453.443 49.6194 453.971 49.0913 453.971 48.4398C453.971 47.7884 453.443 47.2603 452.792 47.2603C452.14 47.2603 451.612 47.7884 451.612 48.4398C451.612 49.0913 452.14 49.6194 452.792 49.6194Z"
                fill="#00B2FF"
              />
              <path
                d="M455.444 51.6589C455.151 51.9795 454.953 52.375 454.872 52.8014C454.291 52.7118 453.702 52.6916 453.116 52.7413C453.073 52.6951 453.03 52.6492 452.982 52.6059C452.641 52.2936 452.215 52.0887 451.757 52.0169C451.3 51.9451 450.832 52.0094 450.411 52.202C449.99 52.3945 449.635 52.7067 449.39 53.0997C449.146 53.4926 449.022 53.9489 449.035 54.4115C448.543 54.8177 448.107 55.2872 447.738 55.8078C447.724 55.795 447.713 55.7811 447.699 55.7686C447.408 55.502 447.054 55.3128 446.671 55.2183C446.287 55.1238 445.886 55.1271 445.505 55.2278C445.123 55.3285 444.772 55.5234 444.485 55.7947C444.198 56.066 443.984 56.405 443.862 56.7806C443.74 57.1561 443.715 57.5563 443.788 57.9444C443.861 58.3325 444.03 58.6961 444.28 59.0018C444.529 59.3076 444.852 59.5457 445.218 59.6944C445.584 59.843 445.981 59.8975 446.373 59.8528C446.357 60.3726 446.395 60.8926 446.488 61.4044C446.112 61.456 445.755 61.5973 445.446 61.8163C445.137 62.0353 444.885 62.3255 444.712 62.6623C444.538 62.9992 444.449 63.3729 444.45 63.7517C444.452 64.1305 444.545 64.5034 444.721 64.8387C444.898 65.174 445.152 65.462 445.463 65.6782C445.774 65.8944 446.133 66.0325 446.508 66.0809C446.884 66.1292 447.266 66.0864 447.622 65.956C447.977 65.8255 448.296 65.6114 448.552 65.3316L448.556 65.3258C448.626 65.3948 448.696 65.4636 448.769 65.5304C449.208 65.9305 449.693 66.2764 450.214 66.5604C449.936 67.2561 449.84 68.0109 449.933 68.7541C450.027 69.4974 450.308 70.2046 450.75 70.8094C451.192 71.4142 451.781 71.8968 452.46 72.2119C453.14 72.527 453.889 72.6642 454.636 72.6108C455.383 72.5573 456.104 72.3149 456.732 71.9062C457.36 71.4975 457.874 70.9361 458.225 70.2745C458.576 69.6129 458.754 68.8729 458.741 68.1238C458.728 67.3748 458.525 66.6414 458.151 65.9924C459.49 64.9932 460.45 63.5681 460.872 61.9513C461.236 62.0795 461.627 62.1163 462.009 62.0584C462.39 62.0006 462.752 61.8498 463.062 61.6195C463.372 61.3892 463.621 61.0862 463.787 60.7373C463.952 60.3884 464.03 60.0042 464.012 59.6184C463.995 59.2326 463.883 58.8569 463.686 58.5245C463.489 58.1921 463.214 57.913 462.884 57.7118C462.555 57.5106 462.181 57.3933 461.795 57.3704C461.41 57.3475 461.024 57.4195 460.673 57.5803C460.302 56.5493 459.704 55.6147 458.923 54.8454L458.928 54.8401C459.138 54.6114 459.3 54.3437 459.406 54.0522C459.512 53.7607 459.559 53.4513 459.545 53.1415C459.531 52.8317 459.456 52.5277 459.325 52.2469C459.194 51.966 459.008 51.7139 458.779 51.5048C458.55 51.2957 458.282 51.1339 457.99 51.0284C457.699 50.923 457.389 50.8761 457.079 50.8905C456.77 50.9048 456.466 50.98 456.185 51.1119C455.905 51.2437 455.653 51.4296 455.444 51.6589Z"
                fill="#00B2FF"
              />
              <path
                d="M489.226 24.2465H463.014V28.1783H489.226V24.2465Z"
                fill="#E6E6E6"
              />
              <path
                d="M16.4986 334.368C25.9479 347.022 45.5629 348.354 45.5629 348.354C45.5629 348.354 49.8575 329.169 40.4081 316.514C30.9588 303.86 11.3438 302.528 11.3438 302.528C11.3438 302.528 7.04922 321.713 16.4986 334.368Z"
                fill="#E6E6E6"
              />
              <path
                d="M64.6357 339.125C58.4003 347.475 45.457 348.354 45.457 348.354C45.457 348.354 42.6231 335.694 48.8584 327.344C55.0938 318.994 68.0371 318.115 68.0371 318.115C68.0371 318.115 70.871 330.774 64.6357 339.125Z"
                fill="#E6E6E6"
              />
              <path
                d="M340.471 377.234H0V378.702H340.471V377.234Z"
                fill="#CCCCCC"
              />
              <path
                d="M521.98 171.733H327.683C326.981 171.733 326.285 171.882 325.636 172.17C324.987 172.458 324.398 172.88 323.901 173.412C323.405 173.944 323.011 174.576 322.742 175.271C322.473 175.967 322.335 176.712 322.335 177.465V293.486C322.335 295.006 322.898 296.463 323.901 297.538C324.904 298.613 326.265 299.217 327.683 299.217H521.98C523.398 299.217 524.758 298.613 525.761 297.538C526.764 296.463 527.328 295.006 527.328 293.486V177.465C527.328 175.945 526.764 174.487 525.761 173.412C524.758 172.337 523.398 171.733 521.98 171.733V171.733Z"
                fill="#3F3D56"
              />
              <path
                d="M520.157 181.862H329.504V297.121H520.157V181.862Z"
                fill="white"
              />
              <path
                d="M424.668 178.719C425.748 178.719 426.624 177.781 426.624 176.623C426.624 175.466 425.748 174.528 424.668 174.528C423.588 174.528 422.713 175.466 422.713 176.623C422.713 177.781 423.588 178.719 424.668 178.719Z"
                fill="white"
              />
              <path
                d="M532.681 295.026H514.074V293.589C514.074 293.552 514.068 293.515 514.054 293.48C514.041 293.445 514.021 293.414 513.997 293.388C513.972 293.361 513.943 293.34 513.91 293.326C513.878 293.311 513.844 293.304 513.809 293.304H507.429C507.394 293.304 507.36 293.311 507.327 293.326C507.295 293.34 507.266 293.361 507.241 293.388C507.217 293.414 507.197 293.445 507.184 293.48C507.17 293.515 507.163 293.552 507.163 293.589V295.026H503.176V293.589C503.176 293.552 503.169 293.515 503.156 293.48C503.143 293.445 503.123 293.414 503.098 293.388C503.074 293.361 503.045 293.34 503.012 293.326C502.98 293.311 502.945 293.304 502.911 293.304H496.531C496.496 293.304 496.462 293.311 496.429 293.326C496.397 293.34 496.368 293.361 496.343 293.388C496.319 293.414 496.299 293.445 496.286 293.48C496.272 293.515 496.265 293.552 496.265 293.589V293.589V295.026H492.278V293.589C492.278 293.552 492.271 293.515 492.258 293.48C492.245 293.445 492.225 293.414 492.2 293.388C492.176 293.361 492.146 293.34 492.114 293.326C492.082 293.311 492.047 293.304 492.012 293.304H485.633C485.598 293.304 485.564 293.311 485.531 293.326C485.499 293.34 485.47 293.361 485.445 293.388C485.42 293.414 485.401 293.445 485.387 293.48C485.374 293.515 485.367 293.552 485.367 293.589V293.589V295.026H481.38V293.589C481.38 293.552 481.373 293.515 481.36 293.48C481.347 293.445 481.327 293.414 481.302 293.388C481.278 293.361 481.248 293.34 481.216 293.326C481.184 293.311 481.149 293.304 481.114 293.304H474.735C474.7 293.304 474.666 293.311 474.633 293.326C474.601 293.34 474.572 293.361 474.547 293.388C474.522 293.414 474.503 293.445 474.489 293.48C474.476 293.515 474.469 293.552 474.469 293.589V295.026H470.482V293.589C470.482 293.552 470.475 293.515 470.462 293.48C470.448 293.445 470.429 293.414 470.404 293.388C470.38 293.361 470.35 293.34 470.318 293.326C470.286 293.311 470.251 293.304 470.216 293.304H463.837C463.802 293.304 463.767 293.311 463.735 293.326C463.703 293.34 463.674 293.361 463.649 293.388C463.624 293.414 463.605 293.445 463.591 293.48C463.578 293.515 463.571 293.552 463.571 293.589V293.589V295.026H459.584V293.589C459.584 293.552 459.577 293.515 459.564 293.48C459.55 293.445 459.531 293.414 459.506 293.388C459.481 293.361 459.452 293.34 459.42 293.326C459.388 293.311 459.353 293.304 459.318 293.304H452.939C452.904 293.304 452.869 293.311 452.837 293.326C452.805 293.34 452.776 293.361 452.751 293.388C452.726 293.414 452.707 293.445 452.693 293.48C452.68 293.515 452.673 293.552 452.673 293.589V293.589V295.026H448.686V293.589C448.686 293.552 448.679 293.515 448.666 293.48C448.652 293.445 448.633 293.414 448.608 293.388C448.583 293.361 448.554 293.34 448.522 293.326C448.49 293.311 448.455 293.304 448.42 293.304H398.448C398.413 293.304 398.379 293.311 398.347 293.326C398.314 293.34 398.285 293.361 398.26 293.388C398.236 293.414 398.216 293.445 398.203 293.48C398.189 293.515 398.183 293.552 398.183 293.589V293.589V295.026H394.195V293.589C394.195 293.552 394.189 293.515 394.175 293.48C394.162 293.445 394.142 293.414 394.118 293.388C394.093 293.361 394.064 293.34 394.031 293.326C393.999 293.311 393.965 293.304 393.93 293.304H387.55C387.515 293.304 387.481 293.311 387.449 293.326C387.416 293.34 387.387 293.361 387.362 293.388C387.338 293.414 387.318 293.445 387.305 293.48C387.291 293.515 387.284 293.552 387.284 293.589V293.589V295.026H383.297V293.589C383.297 293.552 383.29 293.515 383.277 293.48C383.264 293.445 383.244 293.414 383.22 293.388C383.195 293.361 383.166 293.34 383.133 293.326C383.101 293.311 383.066 293.304 383.032 293.304H376.652C376.617 293.304 376.583 293.311 376.55 293.326C376.518 293.34 376.489 293.361 376.464 293.388C376.44 293.414 376.42 293.445 376.407 293.48C376.393 293.515 376.386 293.552 376.386 293.589V293.589V295.026H372.399V293.589C372.399 293.552 372.392 293.515 372.379 293.48C372.366 293.445 372.346 293.414 372.321 293.388C372.297 293.361 372.267 293.34 372.235 293.326C372.203 293.311 372.168 293.304 372.133 293.304H365.754C365.719 293.304 365.685 293.311 365.652 293.326C365.62 293.34 365.591 293.361 365.566 293.388C365.541 293.414 365.522 293.445 365.508 293.48C365.495 293.515 365.488 293.552 365.488 293.589V293.589V295.026H361.501V293.589C361.501 293.552 361.494 293.515 361.481 293.48C361.468 293.445 361.448 293.414 361.423 293.388C361.399 293.361 361.369 293.34 361.337 293.326C361.305 293.311 361.27 293.304 361.235 293.304H354.856C354.821 293.304 354.787 293.311 354.754 293.326C354.722 293.34 354.693 293.361 354.668 293.388C354.643 293.414 354.624 293.445 354.61 293.48C354.597 293.515 354.59 293.552 354.59 293.589V293.589V295.026H350.603V293.589C350.603 293.552 350.596 293.515 350.583 293.48C350.569 293.445 350.55 293.414 350.525 293.388C350.501 293.361 350.471 293.34 350.439 293.326C350.407 293.311 350.372 293.304 350.337 293.304H343.958C343.887 293.304 343.82 293.334 343.77 293.388C343.72 293.441 343.692 293.513 343.692 293.589V295.026H339.705V293.589C339.705 293.552 339.698 293.514 339.685 293.48C339.671 293.445 339.652 293.414 339.627 293.388C339.602 293.361 339.573 293.34 339.541 293.326C339.509 293.311 339.474 293.304 339.439 293.304H333.06C332.989 293.304 332.922 293.334 332.872 293.388C332.822 293.441 332.794 293.513 332.794 293.589V295.026H320.567C319.729 295.026 318.9 295.203 318.126 295.546C317.352 295.89 316.648 296.393 316.056 297.028C315.464 297.663 314.994 298.417 314.673 299.246C314.353 300.076 314.187 300.965 314.188 301.862V304.954C314.188 306.767 314.86 308.506 316.056 309.788C317.252 311.07 318.875 311.791 320.567 311.791H532.681C534.373 311.791 535.995 311.07 537.192 309.788C538.388 308.506 539.06 306.767 539.06 304.954V301.862C539.06 300.965 538.895 300.076 538.575 299.246C538.254 298.417 537.784 297.663 537.192 297.028C536.599 296.393 535.896 295.89 535.122 295.546C534.348 295.203 533.519 295.026 532.681 295.026V295.026Z"
                fill="#3F3D56"
              />
              <path
                d="M407.867 225.747H368.667V228.148H407.867V225.747Z"
                fill="#CBCBCB"
              />
              <path
                d="M407.867 232.949H368.667V236.55H407.867V232.949Z"
                fill="#CBCBCB"
              />
              <path
                d="M407.867 241.351H368.667V243.752H407.867V241.351Z"
                fill="#CBCBCB"
              />
              <path
                d="M363.595 227.264H349.627V242.234H363.595V227.264Z"
                fill="#CBCBCB"
              />
              <path
                d="M407.867 253.354H368.667V255.755H407.867V253.354Z"
                fill="#CBCBCB"
              />
              <path
                d="M407.867 260.556H368.667V264.157H407.867V260.556Z"
                fill="#CBCBCB"
              />
              <path
                d="M407.867 268.958H368.667V271.359H407.867V268.958Z"
                fill="#CBCBCB"
              />
              <path
                d="M363.595 254.871H349.627V269.841H363.595V254.871Z"
                fill="#CBCBCB"
              />
              <path
                d="M420.715 253.36H415.59L424.66 233.606L433.778 253.342H428.649V261.555H420.715V253.36Z"
                fill="white"
              />
              <path
                d="M564.137 312.137H285.197C285.057 312.137 284.922 312.077 284.822 311.97C284.723 311.864 284.667 311.719 284.667 311.568C284.667 311.418 284.723 311.273 284.822 311.166C284.922 311.06 285.057 311 285.197 311H564.137C564.277 311 564.412 311.06 564.512 311.166C564.611 311.273 564.667 311.418 564.667 311.568C564.667 311.719 564.611 311.864 564.512 311.97C564.412 312.077 564.277 312.137 564.137 312.137Z"
                fill="#CBCBCB"
              />
              <path
                d="M415.707 206.542H501.947V273.759H415.707V206.542Z"
                fill="#D9D9D9"
              />
            </g>
            <defs>
              <clipPath id="clip0_4_146">
                <rect width="560" height="378.702" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      <div
        :class="[
          activeslide === 6
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div
          class="hero-image left"
          data-aos="fade-right"
          data-aos-duration="2000"
        >
          <svg
            width="569"
            height="450"
            viewBox="0 0 569 450"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_809_2)">
              <path
                d="M358.554 344.345C314.136 319.715 318.262 306.491 283.347 274.333C266.75 262.819 287.046 222.202 300.493 202.82L318.262 177.206C331.709 157.825 356.064 151.453 372.658 162.974L461.971 224.934C478.572 236.45 481.127 261.495 467.682 280.873L449.912 306.491C436.47 325.861 375.155 355.861 358.554 344.345Z"
                fill="white"
              />
              <path
                d="M444.053 182.802L417.732 164.54C413.394 161.531 407.437 162.607 404.427 166.945L391.025 186.263C388.015 190.601 389.092 196.558 393.43 199.567L419.752 217.829C424.09 220.839 430.046 219.762 433.056 215.424L446.458 196.106C449.468 191.768 448.391 185.812 444.053 182.802Z"
                fill="url(#paint0_linear_809_2)"
              />
              <path
                d="M542.003 183.673C565.533 150.081 549.1 97.976 505.297 67.2931C461.494 36.6102 406.91 38.9685 383.379 72.5606C359.849 106.153 376.283 158.258 420.085 188.941C463.888 219.624 518.472 217.265 542.003 183.673Z"
                fill="white"
              />
              <path
                d="M487.319 189.866L395.979 126.497C393.812 124.994 391.962 123.078 390.535 120.859C389.108 118.64 388.132 116.162 387.662 113.566C387.193 110.97 387.24 108.308 387.8 105.73C388.36 103.152 389.422 100.71 390.926 98.5423L411.374 69.0675C412.744 67.0928 414.842 65.7424 417.207 65.3127C419.572 64.8829 422.011 65.4088 423.988 66.7751L533.434 142.687C535.409 144.057 536.759 146.155 537.189 148.519C537.618 150.884 537.093 153.323 535.726 155.3L515.278 184.775C513.777 186.945 511.862 188.798 509.645 190.229C507.427 191.659 504.949 192.639 502.353 193.111C499.757 193.584 497.093 193.541 494.513 192.984C491.934 192.427 489.489 191.368 487.319 189.866Z"
                fill="url(#paint1_linear_809_2)"
              />
              <path
                d="M486.137 132.412L447.674 105.727C441.338 101.331 432.637 102.904 428.241 109.24L408.659 137.466C404.262 143.802 405.835 152.502 412.172 156.898L450.634 183.583C456.97 187.98 465.671 186.407 470.067 180.07L489.65 151.845C494.046 145.508 492.473 136.808 486.137 132.412Z"
                fill="url(#paint2_linear_809_2)"
              />
              <path
                d="M496.278 178.295L402.891 113.508C400.178 111.624 398.323 108.74 397.736 105.489C397.148 102.239 397.876 98.8876 399.758 96.1731L414.04 75.5811C415.237 73.8564 417.07 72.6776 419.136 72.3042C421.202 71.9307 423.332 72.393 425.057 73.5895L525.906 143.554C526.76 144.147 527.489 144.901 528.052 145.775C528.614 146.649 528.999 147.625 529.184 148.648C529.369 149.671 529.351 150.72 529.131 151.736C528.91 152.751 528.492 153.714 527.9 154.568L513.615 175.158C511.731 177.873 508.847 179.728 505.596 180.316C502.344 180.905 498.993 180.177 496.278 178.295V178.295Z"
                fill="#383838"
              />
              <path
                d="M445.113 118.35C446.554 117.861 447.807 116.935 448.697 115.7C451.527 111.618 449.499 105.312 444.161 101.614C438.823 97.9149 432.21 98.2229 429.377 102.303C428.534 103.568 428.105 105.065 428.15 106.585L445.113 118.35Z"
                fill="white"
              />
              <path
                d="M493.749 152.096C495.19 151.605 496.442 150.678 497.334 149.445C500.167 145.365 498.136 139.057 492.798 135.359C487.459 131.66 480.847 131.968 478.014 136.048C477.17 137.314 476.742 138.81 476.787 140.33L493.749 152.096Z"
                fill="white"
              />
              <path
                d="M401.237 49.1232L395.493 45.1375C394.204 44.2438 392.436 44.5635 391.542 45.8517L377.07 66.7111C376.176 67.9993 376.496 69.7681 377.784 70.6618L383.529 74.6475C384.817 75.5412 386.586 75.2215 387.48 73.9333L401.952 53.074C402.845 51.7858 402.526 50.017 401.237 49.1232Z"
                fill="url(#paint3_linear_809_2)"
              />
              <path
                d="M561.05 159.998L555.305 156.013C554.017 155.119 552.248 155.439 551.354 156.727L536.882 177.586C535.989 178.874 536.308 180.643 537.597 181.537L543.341 185.523C544.629 186.416 546.398 186.097 547.292 184.808L561.764 163.949C562.658 162.661 562.338 160.892 561.05 159.998Z"
                fill="url(#paint4_linear_809_2)"
              />
              <path
                d="M339.746 449.129H64.0423C57.5075 449.121 51.2426 446.522 46.6218 441.901C42.0011 437.281 39.4019 431.016 39.3945 424.481V24.6477C39.4019 18.113 42.0011 11.848 46.6218 7.2273C51.2426 2.60656 57.5075 0.00737978 64.0423 0H339.746C346.281 0.00738174 352.546 2.60656 357.167 7.2273C361.788 11.848 364.387 18.113 364.394 24.6477V424.481C364.387 431.016 361.788 437.281 357.167 441.901C352.546 446.522 346.281 449.121 339.746 449.129Z"
                fill="#3F3D56"
              />
              <path
                d="M340.232 433.403H63.5569C61.5425 433.4 59.6113 432.599 58.1869 431.175C56.7625 429.75 55.9613 427.819 55.959 425.805V23.3237C55.9613 21.3093 56.7625 19.3781 58.1869 17.9537C59.6113 16.5293 61.5425 15.7281 63.5569 15.7258H340.232C342.246 15.7281 344.177 16.5293 345.602 17.9537C347.026 19.3781 347.827 21.3093 347.83 23.3237V425.805C347.827 427.819 347.026 429.75 345.602 431.175C344.177 432.599 342.246 433.4 340.232 433.403Z"
                fill="white"
              />
              <path
                d="M77.0552 200.926C77.8275 190.439 79.1027 177.547 89.4785 171.944C94.3745 169.301 99.5587 170.236 104.481 172.296C109.237 174.288 113.718 176.661 118.841 177.597C127.671 179.121 136.758 177.758 144.753 173.711C152.807 169.707 159.267 163.095 163.084 154.951C165.049 150.809 166.672 146.32 169.567 142.705C171.023 140.808 172.953 139.327 175.164 138.412C177.374 137.497 179.787 137.181 182.158 137.495C193.038 138.838 200.258 148.37 208.931 153.982C213.102 156.681 217.892 158.652 222.943 158.41C228.123 158.162 232.82 155.71 236.79 152.508C245.214 145.715 249.82 135.209 258.661 128.879C262.853 125.952 267.717 124.134 272.8 123.594C277.883 123.054 283.021 123.809 287.734 125.789C296.795 129.698 303.211 138.455 304.905 148.093C305.311 150.468 305.416 152.884 305.217 155.285C305.107 156.701 307.313 156.693 307.423 155.285C307.754 150.29 306.926 145.286 305.003 140.664C303.08 136.042 300.115 131.927 296.339 128.64C288.517 121.892 277.589 119.699 267.65 122.296C262.589 123.638 257.938 126.209 254.109 129.781C250.02 133.552 246.795 138.121 243.343 142.452C239.976 146.678 236.261 150.758 231.534 153.487C229.271 154.866 226.735 155.736 224.102 156.035C221.469 156.335 218.802 156.057 216.287 155.221C211.186 153.5 206.863 149.954 202.781 146.56C198.573 143.06 194.386 139.559 189.328 137.335C184.626 135.268 179.233 134.265 174.338 136.301C169.925 138.137 167.004 141.947 164.839 146.068C162.641 150.252 161.076 154.762 158.512 158.751C156.032 162.569 152.849 165.882 149.133 168.513C141.585 173.906 132.406 176.528 123.148 175.937C118.118 175.579 113.544 173.99 108.989 171.908C103.962 169.61 98.6664 167.219 93.0097 168.333C88.1302 169.293 84.0249 172.608 81.1747 176.568C77.8839 181.141 76.438 186.746 75.6832 192.251C75.2884 195.131 75.0627 198.028 74.8493 200.926C74.745 202.343 76.9514 202.336 77.0552 200.926Z"
                fill="#E4E4E4"
              />
              <path
                d="M30.071 389.235L27.924 400.007C27.7622 400.83 27.5931 401.669 27.4093 402.5C25.6147 402.128 23.7541 402.232 22.0122 402.801C23.3942 404.776 24.6327 406.847 25.7181 409C24.3651 413.169 22.3798 417.022 19.0563 419.808C16.8366 421.628 14.1854 422.845 11.3584 423.343C8.53142 423.84 5.62403 423.6 2.91661 422.647L3.01221 422.22C-0.561323 415.286 1.37985 406.544 5.82102 400.139C8.0862 396.98 10.7701 394.143 13.799 391.706C16.7989 389.206 20.0416 386.963 23.2548 384.75C23.9765 384.253 24.8298 383.983 25.7056 383.975C26.5814 383.966 27.44 384.218 28.1717 384.699C28.9034 385.181 29.4749 385.87 29.8132 386.677C30.1515 387.485 30.2413 388.376 30.071 389.235Z"
                fill="#E4E4E4"
              />
              <path
                d="M3.67933 448.566C2.77566 441.983 1.84625 435.316 2.48007 428.662C3.04331 422.753 4.84551 416.982 8.5161 412.249C10.4643 409.742 12.8349 407.594 15.5213 405.902C16.222 405.461 16.8661 406.57 16.169 407.01C11.521 409.947 7.92597 414.285 5.90212 419.397C3.66683 425.083 3.30801 431.28 3.69624 437.319C3.92933 440.972 4.42272 444.599 4.92051 448.224C4.9606 448.388 4.93648 448.561 4.85309 448.708C4.76971 448.855 4.63337 448.964 4.47198 449.013C4.30781 449.058 4.13279 449.036 3.98492 448.952C3.83706 448.868 3.7283 448.729 3.68227 448.565L3.67933 448.566Z"
                fill="#F2F2F2"
              />
              <path
                d="M200.845 9.64516C202.003 9.64516 202.942 8.7064 202.942 7.54838C202.942 6.39036 202.003 5.4516 200.845 5.4516C199.687 5.4516 198.748 6.39036 198.748 7.54838C198.748 8.7064 199.687 9.64516 200.845 9.64516Z"
                fill="white"
              />
              <path
                d="M323.437 201.645H74.7295C74.5231 201.645 74.3251 201.562 74.1792 201.417C74.0332 201.271 73.9512 201.073 73.9512 200.866L74.3289 200L323.437 200.088C323.643 200.087 323.842 200.168 323.988 200.314C324.135 200.459 324.217 200.657 324.218 200.863C324.219 201.07 324.138 201.268 323.992 201.414C323.847 201.561 323.649 201.644 323.443 201.644L323.437 201.645Z"
                fill="#3F3D56"
              />
              <path
                d="M122.038 196.199H120.512V200.549H122.038V196.199Z"
                fill="#3F3D56"
              />
              <path
                d="M167.741 171.199H166.215V200.549H167.741V171.199Z"
                fill="#3F3D56"
              />
              <path
                d="M213.538 135.905H212.012V200.549H213.538V135.905Z"
                fill="#3F3D56"
              />
              <path
                d="M259.335 105.758H257.809V200.549H259.335V105.758Z"
                fill="#3F3D56"
              />
              <path
                d="M305.132 174.876H303.605V200.549H305.132V174.876Z"
                fill="#3F3D56"
              />
              <path
                d="M258.666 100.475C261.245 100.475 263.336 98.3839 263.336 95.8047C263.336 93.2255 261.245 91.1346 258.666 91.1346C256.087 91.1346 253.996 93.2255 253.996 95.8047C253.996 98.3839 256.087 100.475 258.666 100.475Z"
                fill="#00B0FF"
              />
              <path
                d="M212.602 128.869C215.181 128.869 217.272 126.778 217.272 124.199C217.272 121.62 215.181 119.529 212.602 119.529C210.022 119.529 207.932 121.62 207.932 124.199C207.932 126.778 210.022 128.869 212.602 128.869Z"
                fill="#00B0FF"
              />
              <path
                d="M304.463 170.944C307.042 170.944 309.133 168.853 309.133 166.273C309.133 163.694 307.042 161.603 304.463 161.603C301.884 161.603 299.793 163.694 299.793 166.273C299.793 168.853 301.884 170.944 304.463 170.944Z"
                fill="#00B0FF"
              />
              <path
                d="M165.758 363.61V308.508C165.758 307.802 166.58 307.229 167.594 307.229H175.786C176.8 307.229 177.622 307.802 177.622 308.508V363.754L165.758 363.61Z"
                fill="#3F3D56"
              />
              <path
                d="M192.816 363.796V321.694C192.816 321.014 193.638 320.464 194.652 320.464H202.845C203.859 320.464 204.681 321.014 204.681 321.694V363.705L192.816 363.796Z"
                fill="#3F3D56"
              />
              <path
                d="M246.936 363.698V342.285C246.864 342.029 247.683 341.807 248.772 341.788H256.965C258.053 341.807 258.872 342.029 258.8 342.285V363.754L246.936 363.698Z"
                fill="#3F3D56"
              />
              <path
                d="M138.699 363.698V342.285C138.699 342.01 139.521 341.788 140.535 341.788H148.728C149.742 341.788 150.564 342.01 150.564 342.285V363.754L138.699 363.698Z"
                fill="#3F3D56"
              />
              <path
                d="M219.877 363.484V260.083C219.877 258.756 220.699 257.681 221.713 257.681H229.906C230.919 257.681 231.741 258.756 231.741 260.083V363.754L219.877 363.484Z"
                fill="#00B0FF"
              />
              <path
                d="M294.109 364.706H108.815C108.62 364.706 108.433 364.628 108.295 364.491C108.158 364.353 108.08 364.166 108.08 363.971C108.08 363.776 108.158 363.589 108.295 363.451C108.433 363.313 108.62 363.235 108.815 363.235H294.109C294.304 363.235 294.491 363.313 294.629 363.451C294.767 363.589 294.845 363.776 294.845 363.971C294.845 364.166 294.767 364.353 294.629 364.491C294.491 364.628 294.304 364.706 294.109 364.706Z"
                fill="#3F3D56"
              />
              <path
                d="M669 450H-102C-102.265 450 -102.52 449.923 -102.707 449.785C-102.895 449.647 -103 449.46 -103 449.265C-103 449.07 -102.895 448.883 -102.707 448.745C-102.52 448.607 -102.265 448.529 -102 448.529H669C669.265 448.529 669.52 448.607 669.707 448.745C669.895 448.883 670 449.07 670 449.265C670 449.46 669.895 449.647 669.707 449.785C669.52 449.923 669.265 450 669 450Z"
                fill="#CACACA"
              />
              <path
                d="M121.67 192.34C124.249 192.34 126.34 190.249 126.34 187.67C126.34 185.091 124.249 183 121.67 183C119.091 183 117 185.091 117 187.67C117 190.249 119.091 192.34 121.67 192.34Z"
                fill="#00B0FF"
              />
              <path
                d="M166.67 168.34C169.249 168.34 171.34 166.249 171.34 163.67C171.34 161.091 169.249 159 166.67 159C164.091 159 162 161.091 162 163.67C162 166.249 164.091 168.34 166.67 168.34Z"
                fill="#00B0FF"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_809_2"
                x1="362.068"
                y1="-85.4866"
                x2="508.713"
                y2="630.81"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#5D535A" />
                <stop offset="1" stop-color="#464143" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_809_2"
                x1="402.919"
                y1="-68.4338"
                x2="530.889"
                y2="361.166"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#5D535A" />
                <stop offset="1" stop-color="#464143" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_809_2"
                x1="377.922"
                y1="-94.3614"
                x2="523.389"
                y2="393.994"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#5D535A" />
                <stop offset="1" stop-color="#464143" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_809_2"
                x1="376.844"
                y1="34.2613"
                x2="433.57"
                y2="149.337"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#5D535A" />
                <stop offset="1" stop-color="#464143" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_809_2"
                x1="452.694"
                y1="-25.1692"
                x2="509.42"
                y2="89.9059"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#5D535A" />
                <stop offset="1" stop-color="#464143" />
              </linearGradient>
              <clipPath id="clip0_809_2">
                <rect width="568.382" height="450" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div class="hero-text">
          <h3 class="inner" style="--delay: 0.1s">
            Quick and Ready to use <b>AI generated SOPs, Protocols</b> and
            <b>Forms</b>
          </h3>
          <h2 class="slide inner" style="--delay: 0.3s">
            Streamline your pharmaceutical documentation process with
            AI-generated SOPs, protocols, and forms, saving time and ensuring
            compliance
          </h2>
          <div class="cta inner" style="--delay: 0.5s">
            <button class="primary btn">
              <a href="#sign-up">Try Now</a>
            </button>
          </div>
        </div>
      </div>

      <div
        :class="[
          activeslide === 7
            ? 'grid center slides active'
            : 'grid center slides',
        ]"
      >
        <div class="hero-text">
          <h3 class="inner" style="--delay: 0.1s">
            Hands-free Integrated <b>IoT Tools</b>
          </h3>
          <h2 class="slide inner" style="--delay: 0.3s">
            Live Video Collaboration, Monitoring & Supervision Voice Notes,
            E-training, Troubleshooting, FAQs Virtual Audits & Inspection, Video
            Doc Creation
          </h2>
          <div class="cta inner" style="--delay: 0.5s">
            <button class="primary btn">
              <a href="#sign-up">Pre-order Now</a>
            </button>
          </div>
        </div>

        <div
          class="hero-image right"
          data-aos="fade-left"
          data-aos-duration="2000"
        >
          <svg
            class="img"
            width="630"
            height="529"
            viewBox="0 0 630 529"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g clip-path="url(#clip0_423_332)">
              <path
                d="M606.098 163H365.308C364.438 163 363.576 163.184 362.772 163.541C361.968 163.898 361.237 164.421 360.622 165.08C360.006 165.74 359.518 166.523 359.185 167.385C358.852 168.246 358.681 169.17 358.681 170.103V313.886C358.681 315.77 359.379 317.576 360.622 318.908C361.865 320.24 363.55 320.989 365.308 320.989H606.098C607.856 320.989 609.542 320.24 610.784 318.908C612.027 317.576 612.726 315.77 612.726 313.886V170.103C612.726 168.219 612.027 166.412 610.784 165.08C609.542 163.748 607.856 163 606.098 163V163Z"
                fill="#3F3D56"
              />
              <path
                d="M603.839 175.553H367.565V318.392H603.839V175.553Z"
                fill="white"
              />
              <path
                d="M485.499 171.657C486.838 171.657 487.923 170.494 487.923 169.06C487.923 167.626 486.838 166.463 485.499 166.463C484.161 166.463 483.076 167.626 483.076 169.06C483.076 170.494 484.161 171.657 485.499 171.657Z"
                fill="white"
              />
              <path
                d="M619.36 315.795H596.301V314.014C596.301 313.968 596.293 313.922 596.276 313.879C596.26 313.836 596.235 313.797 596.205 313.764C596.174 313.732 596.138 313.706 596.098 313.688C596.058 313.67 596.015 313.661 595.972 313.661H588.066C588.023 313.661 587.98 313.67 587.94 313.688C587.9 313.706 587.864 313.732 587.833 313.764C587.803 313.797 587.778 313.836 587.762 313.879C587.745 313.922 587.737 313.968 587.737 314.014V315.795H582.796V314.014C582.796 313.968 582.787 313.922 582.77 313.879C582.754 313.836 582.73 313.797 582.699 313.764C582.668 313.732 582.632 313.706 582.592 313.688C582.552 313.67 582.509 313.661 582.466 313.661H574.56C574.517 313.661 574.474 313.67 574.434 313.688C574.394 313.706 574.358 313.732 574.327 313.764C574.297 313.797 574.272 313.836 574.256 313.879C574.239 313.922 574.231 313.968 574.231 314.014V314.014V315.795H569.29V314.014C569.29 313.968 569.281 313.922 569.265 313.879C569.248 313.836 569.224 313.797 569.193 313.764C569.163 313.732 569.126 313.706 569.086 313.688C569.046 313.67 569.004 313.661 568.96 313.661H561.054C561.011 313.661 560.968 313.67 560.928 313.688C560.888 313.706 560.852 313.732 560.821 313.764C560.791 313.797 560.767 313.836 560.75 313.879C560.733 313.922 560.725 313.968 560.725 314.014V314.014V315.795H555.784V314.014C555.784 313.968 555.775 313.922 555.759 313.879C555.742 313.836 555.718 313.797 555.687 313.764C555.657 313.732 555.62 313.706 555.58 313.688C555.54 313.67 555.498 313.661 555.454 313.661H547.548C547.505 313.661 547.462 313.67 547.422 313.688C547.383 313.706 547.346 313.732 547.316 313.764C547.285 313.797 547.261 313.836 547.244 313.879C547.228 313.922 547.219 313.968 547.219 314.014V315.795H542.278V314.014C542.278 313.968 542.269 313.922 542.253 313.879C542.236 313.836 542.212 313.797 542.181 313.764C542.151 313.732 542.115 313.706 542.075 313.688C542.035 313.67 541.992 313.661 541.949 313.661H534.043C533.999 313.661 533.957 313.67 533.917 313.688C533.877 313.706 533.84 313.732 533.81 313.764C533.779 313.797 533.755 313.836 533.738 313.879C533.722 313.922 533.713 313.968 533.713 314.014V314.014V315.795H528.772V314.014C528.772 313.968 528.764 313.922 528.747 313.879C528.73 313.836 528.706 313.797 528.676 313.764C528.645 313.732 528.609 313.706 528.569 313.688C528.529 313.67 528.486 313.661 528.443 313.661H520.537C520.493 313.661 520.451 313.67 520.411 313.688C520.371 313.706 520.334 313.732 520.304 313.764C520.273 313.797 520.249 313.836 520.232 313.879C520.216 313.922 520.207 313.968 520.207 314.014V314.014V315.795H515.266V314.014C515.266 313.968 515.258 313.922 515.241 313.879C515.225 313.836 515.2 313.797 515.17 313.764C515.139 313.732 515.103 313.706 515.063 313.688C515.023 313.67 514.98 313.661 514.937 313.661H453.007C452.964 313.661 452.921 313.67 452.881 313.688C452.841 313.706 452.805 313.732 452.774 313.764C452.744 313.797 452.72 313.836 452.703 313.879C452.687 313.922 452.678 313.968 452.678 314.014V314.014V315.795H447.737V314.014C447.737 313.968 447.728 313.922 447.712 313.879C447.695 313.836 447.671 313.797 447.64 313.764C447.61 313.732 447.573 313.706 447.533 313.688C447.494 313.67 447.451 313.661 447.407 313.661H439.502C439.458 313.661 439.415 313.67 439.375 313.688C439.336 313.706 439.299 313.732 439.269 313.764C439.238 313.797 439.214 313.836 439.197 313.879C439.181 313.922 439.172 313.968 439.172 314.014V314.014V315.795H434.231V314.014C434.231 313.968 434.222 313.922 434.206 313.879C434.189 313.836 434.165 313.797 434.135 313.764C434.104 313.732 434.068 313.706 434.028 313.688C433.988 313.67 433.945 313.661 433.902 313.661H425.996C425.952 313.661 425.91 313.67 425.87 313.688C425.83 313.706 425.793 313.732 425.763 313.764C425.732 313.797 425.708 313.836 425.691 313.879C425.675 313.922 425.666 313.968 425.666 314.014V314.014V315.795H420.725V314.014C420.725 313.968 420.717 313.922 420.7 313.879C420.683 313.836 420.659 313.797 420.629 313.764C420.598 313.732 420.562 313.706 420.522 313.688C420.482 313.67 420.439 313.661 420.396 313.661H412.49C412.447 313.661 412.404 313.67 412.364 313.688C412.324 313.706 412.287 313.732 412.257 313.764C412.226 313.797 412.202 313.836 412.185 313.879C412.169 313.922 412.16 313.968 412.16 314.014V314.014V315.795H407.219V314.014C407.219 313.968 407.211 313.922 407.194 313.879C407.178 313.836 407.153 313.797 407.123 313.764C407.092 313.732 407.056 313.706 407.016 313.688C406.976 313.67 406.933 313.661 406.89 313.661H398.984C398.941 313.661 398.898 313.67 398.858 313.688C398.818 313.706 398.782 313.732 398.751 313.764C398.72 313.797 398.696 313.836 398.68 313.879C398.663 313.922 398.655 313.968 398.655 314.014V314.014V315.795H393.713V314.014C393.713 313.968 393.705 313.922 393.688 313.879C393.672 313.836 393.647 313.797 393.617 313.764C393.586 313.732 393.55 313.706 393.51 313.688C393.47 313.67 393.427 313.661 393.384 313.661H385.478C385.391 313.661 385.307 313.698 385.245 313.764C385.183 313.831 385.149 313.92 385.149 314.014V315.795H380.207V314.014C380.207 313.968 380.199 313.922 380.182 313.879C380.166 313.836 380.142 313.797 380.111 313.764C380.08 313.732 380.044 313.706 380.004 313.688C379.964 313.67 379.921 313.661 379.878 313.661H371.972C371.885 313.661 371.801 313.698 371.739 313.764C371.677 313.831 371.643 313.92 371.643 314.014V315.795H356.49C355.452 315.795 354.424 316.014 353.464 316.44C352.505 316.865 351.634 317.489 350.9 318.276C350.165 319.063 349.583 319.997 349.186 321.025C348.788 322.053 348.584 323.155 348.584 324.267V328.098C348.584 330.346 349.417 332.501 350.9 334.09C352.382 335.679 354.393 336.571 356.49 336.571H619.36C621.457 336.571 623.468 335.679 624.95 334.09C626.433 332.501 627.266 330.346 627.266 328.098V324.267C627.266 323.155 627.062 322.053 626.664 321.025C626.267 319.997 625.685 319.063 624.95 318.276C624.216 317.489 623.345 316.865 622.386 316.44C621.426 316.014 620.398 315.795 619.36 315.795V315.795Z"
                fill="#3F3D56"
              />
              <path
                d="M464.679 229.939H416.099V232.914H464.679V229.939Z"
                fill="#CBCBCB"
              />
              <path
                d="M464.679 238.864H416.099V243.326H464.679V238.864Z"
                fill="#CBCBCB"
              />
              <path
                d="M464.679 249.276H416.099V252.251H464.679V249.276Z"
                fill="#CBCBCB"
              />
              <path
                d="M409.814 231.819H392.503V250.371H409.814V231.819Z"
                fill="#CBCBCB"
              />
              <path
                d="M464.679 264.152H416.099V267.127H464.679V264.152Z"
                fill="#CBCBCB"
              />
              <path
                d="M464.679 273.077H416.099V277.539H464.679V273.077Z"
                fill="#CBCBCB"
              />
              <path
                d="M464.679 283.489H416.099V286.464H464.679V283.489Z"
                fill="#CBCBCB"
              />
              <path
                d="M409.814 266.032H392.503V284.584H409.814V266.032Z"
                fill="#CBCBCB"
              />
              <path
                d="M480.602 264.159H474.25L485.491 239.678L496.791 264.137H490.433V274.315H480.602V264.159Z"
                fill="white"
              />
              <path
                d="M658.342 337H312.656C312.482 337 312.315 336.926 312.192 336.794C312.068 336.662 311.999 336.482 311.999 336.296C311.999 336.109 312.068 335.93 312.192 335.798C312.315 335.666 312.482 335.591 312.656 335.591H658.342C658.517 335.591 658.684 335.666 658.807 335.798C658.93 335.93 659 336.109 659 336.296C659 336.482 658.93 336.662 658.807 336.794C658.684 336.926 658.517 337 658.342 337Z"
                fill="#CBCBCB"
              />
              <path
                d="M474.396 206.138H581.273V289.439H474.396V206.138Z"
                fill="#D9D9D9"
              />
              <path
                d="M534.353 259.861H538.023V260.353H534.353V259.861Z"
                fill="#CCCCCC"
              />
              <path
                d="M534.353 256.911H538.023V257.402H534.353V256.911Z"
                fill="#CCCCCC"
              />
              <path
                d="M534.353 255.927H538.023V256.419H534.353V255.927Z"
                fill="#CCCCCC"
              />
              <path
                d="M525.866 280.514C529.457 280.514 532.806 280.263 535.296 279.807C538.368 279.245 539.861 278.428 539.861 277.309L539.86 277.274L534.468 232.847L537.167 224.473C537.297 224.079 537.336 223.657 537.28 223.243C537.225 222.829 537.077 222.436 536.85 222.098C536.628 221.755 536.331 221.476 535.985 221.287C535.64 221.098 535.256 221.004 534.869 221.014L516.994 221.216C516.615 221.22 516.242 221.321 515.906 221.511C515.571 221.7 515.281 221.973 515.061 222.307C514.841 222.641 514.697 223.026 514.641 223.432C514.585 223.837 514.618 224.251 514.738 224.64L517.265 232.844L511.872 277.275V277.292C511.871 278.498 513.562 279.354 517.04 279.91C520.458 280.455 524.351 280.514 525.866 280.514Z"
                fill="white"
                fill-opacity="0.6"
              />
              <path
                d="M525.866 280.514C529.457 280.514 532.806 280.263 535.296 279.807C538.368 279.245 539.861 278.428 539.861 277.309L539.86 277.274L534.468 232.847L537.167 224.473C537.297 224.079 537.336 223.657 537.28 223.243C537.225 222.829 537.077 222.436 536.85 222.098C536.628 221.755 536.331 221.476 535.985 221.287C535.64 221.098 535.256 221.004 534.869 221.014L516.994 221.216C516.615 221.22 516.242 221.321 515.906 221.511C515.571 221.7 515.281 221.973 515.061 222.307C514.841 222.641 514.697 223.026 514.641 223.432C514.585 223.837 514.618 224.251 514.738 224.64L517.265 232.844L511.872 277.275V277.292C511.871 278.498 513.562 279.354 517.04 279.91C520.458 280.455 524.351 280.514 525.866 280.514ZM534.918 221.545C535.219 221.545 535.516 221.623 535.783 221.773C536.049 221.924 536.279 222.141 536.451 222.408C536.632 222.677 536.75 222.99 536.794 223.319C536.838 223.649 536.807 223.985 536.704 224.298L533.966 232.791L533.973 232.853L539.371 277.327C539.37 277.762 538.83 278.621 535.214 279.283C532.75 279.734 529.43 279.983 525.866 279.983C522.733 279.983 519.46 279.759 517.112 279.384C514.112 278.905 512.384 278.149 512.363 277.308L517.766 232.792L515.204 224.472C515.108 224.163 515.082 223.833 515.127 223.511C515.171 223.188 515.286 222.881 515.461 222.616C515.636 222.35 515.866 222.133 516.134 221.982C516.401 221.831 516.697 221.75 516.999 221.747L534.877 221.545C534.891 221.545 534.905 221.545 534.918 221.545Z"
                fill="#989898"
              />
              <path
                opacity="0.5"
                d="M515.543 271.663H536.191L532.918 247.995L532.829 247.343L531.465 237.49C531.382 236.889 530.735 237.355 530.278 236.995C527.437 234.758 524.562 234.693 521.663 236.849C521.215 237.183 520.596 236.793 520.512 237.369L519.079 247.252L518.941 248.208L515.543 271.663Z"
                fill="#00B0FF"
              />
              <path
                d="M517.967 275.105H533.768C534.182 275.105 534.591 275.011 534.968 274.829C535.345 274.647 535.68 274.382 535.95 274.051C536.221 273.72 536.421 273.331 536.536 272.912C536.652 272.492 536.68 272.051 536.619 271.619L532.003 238.683C531.979 238.515 531.914 238.356 531.813 238.223C531.712 238.09 531.58 237.987 531.43 237.925C531.279 237.863 531.116 237.845 530.957 237.871C530.797 237.897 530.647 237.967 530.522 238.074C527.708 240.452 524.642 240.398 521.408 237.915C521.283 237.819 521.136 237.758 520.981 237.739C520.827 237.72 520.671 237.744 520.528 237.807C520.381 237.871 520.253 237.973 520.156 238.104C520.058 238.235 519.995 238.39 519.971 238.555L515.119 271.598C515.055 272.032 515.081 272.475 515.195 272.897C515.309 273.319 515.508 273.71 515.779 274.043C516.049 274.376 516.385 274.643 516.763 274.827C517.141 275.01 517.552 275.105 517.967 275.105Z"
                fill="#00B0FF"
              />
              <path
                d="M524.264 271.171H532.982V271.663H524.264V271.171Z"
                fill="white"
              />
              <path
                d="M524.264 268.221H532.982V268.712H524.264V268.221Z"
                fill="white"
              />
              <path
                d="M524.264 264.778H532.982V265.762H524.264V264.778Z"
                fill="white"
              />
              <path
                d="M524.264 261.336H532.982V262.32H524.264V261.336Z"
                fill="white"
              />
              <path
                d="M518.753 250.043C519.432 250.726 520.25 251.251 521.15 251.584C522.05 251.917 523.011 252.049 523.966 251.972C525.055 251.872 526.048 251.461 527.005 250.943C527.993 250.407 528.95 249.767 530.044 249.468C531.003 249.206 532.139 249.171 532.962 249.819C533.03 249.872 533.112 249.901 533.197 249.903C533.282 249.906 533.366 249.88 533.436 249.831L533.342 249.183C532.425 248.536 531.311 248.436 530.219 248.658C528.02 249.106 526.352 250.945 524.099 251.209C523.127 251.32 522.143 251.185 521.236 250.816C520.329 250.447 519.526 249.856 518.9 249.096L518.898 249.094L518.753 250.043Z"
                fill="white"
              />
              <rect
                x="382.788"
                y="188.288"
                width="65.2361"
                height="25.2879"
                rx="6"
                fill="#D42E4C"
              />
              <path
                d="M407.796 203.416H410.484V205H405.744V196.576H407.796V203.416ZM414.955 196.576V205H412.903V196.576H414.955ZM425.79 196.576L422.802 205H420.234L417.246 196.576H419.43L421.518 202.936L423.618 196.576H425.79ZM430.139 198.22V199.924H432.887V201.508H430.139V203.356H433.247V205H428.087V196.576H433.247V198.22H430.139Z"
                fill="white"
              />
              <ellipse cx="396.799" cy="201" rx="2.79929" ry="3" fill="white" />
              <path
                d="M234.472 112.36C234.033 113.632 233.324 114.792 232.394 115.758C231.463 116.723 230.335 117.471 229.087 117.949C227.839 118.427 226.502 118.623 225.171 118.523C223.84 118.423 222.547 118.03 221.383 117.371L142.205 143L116 122.253L218.129 104.208C219.356 102.308 221.23 100.928 223.397 100.329C225.564 99.73 227.874 99.9543 229.889 100.959C231.903 101.964 233.482 103.68 234.327 105.781C235.172 107.882 235.223 110.223 234.472 112.36V112.36Z"
                fill="#FFB6B6"
              />
              <path
                d="M87.3131 146.892C87.3131 146.892 88.0303 145.115 97.4999 148.982C109.254 153.782 171.832 150.573 175.299 133.328C176.406 134.483 177.862 135.233 179.438 135.46C181.013 135.687 182.618 135.377 184 134.58L174.217 112.879C169.125 111.234 166.358 110.016 166.029 112.112L150.719 111.202L88.7139 121.752L87 143.384L87.3131 146.892Z"
                fill="#F2F2F2"
              />
              <path
                d="M106.947 124.683L76.1236 122L47.2267 135.283L31 361L94.6788 331.387L122 338.988L106.947 124.683Z"
                fill="#F2F2F2"
              />
              <path
                d="M31.0017 518L42.5201 517.999L48 473L31 473.001L31.0017 518Z"
                fill="#FFB6B6"
              />
              <path
                d="M28.0007 529L66 528.999V528.531C65.9997 524.711 64.4413 521.048 61.6677 518.347C58.894 515.646 55.1321 514.128 51.2096 514.128H51.2087L44.2676 509L31.3171 514.129L28 514.129L28.0007 529Z"
                fill="#2F2E41"
              />
              <path
                d="M76 510.401L87.5052 513L103 469.836L86.0192 466L76 510.401Z"
                fill="#FFB6B6"
              />
              <path
                d="M71 520.57L107.538 529L107.642 528.528C108.494 524.674 107.812 520.632 105.747 517.291C103.682 513.951 100.404 511.585 96.6322 510.714L96.6313 510.714L91.1007 504L77.5048 506.301L74.3153 505.565L71 520.57Z"
                fill="#2F2E41"
              />
              <path
                d="M15.7749 241C10.2686 257.617 10.8507 275.654 17.0984 295.013L19.7692 404.008C15.3539 408.87 14.6788 452.374 21.4802 466.57C30.5625 485.526 22.2101 488.06 28.6302 500.636H47.2521L55.8587 443.662L56.472 397.48C58.9453 391.621 56.9148 371 56.9148 371L57.6298 328.241L91.2064 403.145C75.9944 416.173 77.3637 458.257 77.1125 476.924L72.1248 498.95L95.0439 501L105.158 471.129L116.53 452.722C122.325 420.107 124.043 396.164 119.102 386.383L85.3965 260.904L15.7749 241Z"
                fill="#2F2E41"
              />
              <path
                d="M13.3629 236.046L16.4275 229.899C20.1792 206.593 23.8857 184.854 18.8503 165.301C18.5339 148.231 23.7953 132.194 38.4042 123.437L44.9946 119.485L48.3303 111L79.049 111.752L79.1393 122.875L90.1412 140.471V140.544L89.4542 236.29L86.4167 246.172L91 257.666L88.5682 265L28.008 255.291L20.9657 254.158C20.1526 253.897 19.368 253.554 18.6242 253.134C16.0974 251.726 14.1166 249.507 13.0013 246.833C12.938 246.679 12.8837 246.534 12.8295 246.38C12.3544 245.132 12.0798 243.816 12.0159 242.482C11.9058 240.256 12.3697 238.039 13.3629 236.046V236.046Z"
                fill="#3F3D56"
              />
              <path
                opacity="0.2"
                d="M12 242.26C12.0635 243.587 12.3362 244.896 12.808 246.137L18.5624 252.854C19.301 253.272 20.08 253.613 20.8875 253.873L27.8807 255L17.7634 235.895L40 187L12 242.26Z"
                fill="black"
              />
              <path
                d="M323.064 254.997C325.92 255.027 328.775 254.824 331.6 254.389C334.231 253.931 335.564 253.28 335.564 252.455L335.563 252.44L330.656 213.979L333.128 206.686C333.231 206.38 333.262 206.052 333.217 205.731C333.172 205.41 333.052 205.105 332.869 204.842C332.685 204.578 332.442 204.364 332.161 204.218C331.88 204.071 331.569 203.997 331.254 204L315 204.174C314.691 204.178 314.387 204.256 314.112 204.403C313.838 204.551 313.602 204.763 313.422 205.022C313.243 205.281 313.125 205.58 313.079 205.895C313.034 206.21 313.061 206.532 313.158 206.834L315.472 213.978L310.564 252.44C310.563 254.462 318.421 254.997 323.064 254.997Z"
                fill="#F2F2F2"
                fill-opacity="0.8"
              />
              <path d="M324.564 249H332.564V250H324.564V249Z" fill="#CCCCCC" />
              <path d="M324.564 243H332.564V244H324.564V243Z" fill="#CCCCCC" />
              <path d="M324.564 241H332.564V242H324.564V241Z" fill="#CCCCCC" />
              <path
                d="M250.064 254.997C252.92 255.027 255.775 254.824 258.6 254.389C261.231 253.931 262.564 253.28 262.564 252.455L262.563 252.44L257.656 213.979L260.128 206.686C260.231 206.38 260.262 206.052 260.217 205.731C260.172 205.41 260.052 205.105 259.869 204.842C259.685 204.578 259.442 204.364 259.161 204.218C258.88 204.071 258.569 203.997 258.254 204L242 204.174C241.691 204.178 241.387 204.256 241.112 204.403C240.838 204.551 240.602 204.763 240.422 205.022C240.243 205.281 240.125 205.58 240.079 205.895C240.034 206.21 240.061 206.532 240.158 206.834L242.472 213.978L237.564 252.44C237.563 254.462 245.421 254.997 250.064 254.997Z"
                fill="#F2F2F2"
                fill-opacity="0.8"
              />
              <path d="M251.564 249H259.564V250H251.564V249Z" fill="#CCCCCC" />
              <path d="M251.564 243H259.564V244H251.564V243Z" fill="#CCCCCC" />
              <path d="M251.564 241H259.564V242H251.564V241Z" fill="#CCCCCC" />
              <path
                d="M284.064 254.997C286.92 255.027 289.775 254.824 292.6 254.389C295.231 253.931 296.564 253.28 296.564 252.455L296.563 252.44L291.656 213.979L294.128 206.686C294.231 206.38 294.262 206.052 294.217 205.731C294.172 205.41 294.052 205.105 293.869 204.842C293.685 204.578 293.442 204.364 293.161 204.218C292.88 204.071 292.569 203.997 292.254 204L276 204.174C275.691 204.178 275.387 204.256 275.112 204.403C274.838 204.551 274.602 204.763 274.422 205.022C274.243 205.281 274.125 205.58 274.079 205.895C274.034 206.21 274.061 206.532 274.158 206.834L276.472 213.978L271.564 252.44C271.563 254.462 279.421 254.997 284.064 254.997Z"
                fill="#F2F2F2"
                fill-opacity="0.8"
              />
              <path d="M286.564 249H293.564V250H286.564V249Z" fill="#CCCCCC" />
              <path d="M286.564 243H293.564V244H286.564V243Z" fill="#CCCCCC" />
              <path d="M286.564 241H293.564V242H286.564V241Z" fill="#CCCCCC" />
              <path
                d="M230.747 257.576H246.189V231.423H230.747C229.904 231.423 229.095 231.085 228.499 230.483C227.903 229.88 227.568 229.064 227.568 228.212C227.568 227.36 227.903 226.543 228.499 225.941C229.095 225.338 229.904 225 230.747 225H338.385C339.228 225 340.037 225.338 340.633 225.941C341.23 226.543 341.564 227.36 341.564 228.212C341.564 229.064 341.23 229.88 340.633 230.483C340.037 231.085 339.228 231.423 338.385 231.423H325.214V257.576H338.385C339.228 257.576 340.037 257.915 340.633 258.517C341.23 259.119 341.564 259.936 341.564 260.788C341.564 261.64 341.23 262.457 340.633 263.059C340.037 263.662 339.228 264 338.385 264H230.747C230.329 264 229.915 263.918 229.529 263.756C229.143 263.595 228.792 263.359 228.497 263.06C228.201 262.762 227.967 262.408 227.807 262.018C227.647 261.628 227.564 261.21 227.564 260.788C227.564 260.366 227.647 259.948 227.807 259.558C227.967 259.168 228.201 258.814 228.497 258.516C228.792 258.218 229.143 257.981 229.529 257.82C229.915 257.659 230.329 257.576 230.747 257.576ZM318.856 257.576V231.423H252.547V257.576H318.856Z"
                fill="#CCCCCC"
              />
              <path
                d="M233.063 291C240.889 291 248.188 290.489 253.615 289.562C260.31 288.419 263.564 286.757 263.564 284.482L263.561 284.411L251.81 194.065L257.693 177.036C257.975 176.235 258.06 175.376 257.94 174.534C257.819 173.693 257.497 172.894 257.002 172.206C256.518 171.508 255.87 170.941 255.117 170.556C254.364 170.172 253.528 169.981 252.684 170.001L213.727 170.411C212.902 170.42 212.09 170.625 211.357 171.011C210.625 171.397 209.994 171.952 209.514 172.631C209.035 173.31 208.721 174.094 208.599 174.918C208.477 175.743 208.549 176.585 208.81 177.376L214.317 194.058L202.564 284.412V284.447C202.563 286.9 206.248 288.641 213.829 289.771C221.276 290.88 229.761 291 233.063 291Z"
                fill="white"
                fill-opacity="0.5"
              />
              <path
                d="M233.063 291C240.889 291 248.188 290.489 253.615 289.562C260.31 288.419 263.564 286.757 263.564 284.482L263.561 284.411L251.81 194.065L257.693 177.036C257.975 176.235 258.06 175.376 257.94 174.534C257.819 173.693 257.497 172.894 257.002 172.206C256.518 171.508 255.87 170.941 255.117 170.556C254.364 170.172 253.528 169.981 252.684 170.001L213.727 170.411C212.902 170.42 212.09 170.625 211.357 171.011C210.625 171.397 209.994 171.952 209.514 172.631C209.035 173.31 208.721 174.094 208.599 174.918C208.477 175.743 208.549 176.585 208.81 177.376L214.317 194.058L202.564 284.412V284.447C202.563 286.9 206.248 288.641 213.829 289.771C221.276 290.88 229.761 291 233.063 291ZM252.792 171.081C253.447 171.08 254.094 171.24 254.675 171.545C255.257 171.851 255.757 172.294 256.132 172.837C256.527 173.384 256.783 174.02 256.879 174.689C256.975 175.359 256.907 176.042 256.683 176.68L250.716 193.951L250.732 194.078L262.496 284.518C262.494 285.404 261.317 287.151 253.436 288.496C248.067 289.414 240.831 289.919 233.063 289.919C226.235 289.919 219.103 289.464 213.985 288.701C207.447 287.727 203.68 286.19 203.635 284.48L215.41 193.953L209.826 177.034C209.618 176.405 209.56 175.735 209.658 175.078C209.755 174.422 210.005 173.799 210.386 173.258C210.767 172.718 211.27 172.276 211.852 171.969C212.435 171.662 213.081 171.499 213.738 171.492L252.701 171.082C252.731 171.081 252.762 171.081 252.792 171.081Z"
                fill="#C4C4C4"
                fill-opacity="0.8"
              />
              <path
                opacity="0.5"
                d="M210.564 273H255.564L248.431 224.869L248.237 223.543L245.265 203.506C245.083 202.284 243.673 203.233 242.676 202.5C236.485 197.951 230.22 197.819 223.901 202.204C222.924 202.881 221.575 202.088 221.393 203.261L218.271 223.359L217.969 225.303L210.564 273Z"
                fill="#00B0FF"
              />
              <path
                d="M215.847 280H250.282C251.185 280 252.077 279.808 252.898 279.438C253.718 279.068 254.449 278.529 255.038 277.856C255.628 277.183 256.064 276.393 256.315 275.539C256.567 274.686 256.629 273.789 256.497 272.91L246.436 205.933C246.384 205.59 246.241 205.268 246.022 204.997C245.802 204.726 245.514 204.518 245.187 204.392C244.859 204.266 244.503 204.228 244.156 204.281C243.808 204.334 243.481 204.476 243.207 204.694C237.076 209.53 230.393 209.421 223.345 204.372C223.072 204.175 222.752 204.051 222.415 204.013C222.079 203.974 221.738 204.022 221.426 204.152C221.108 204.28 220.829 204.488 220.616 204.755C220.404 205.021 220.265 205.337 220.213 205.672L209.638 272.868C209.5 273.75 209.556 274.651 209.805 275.509C210.053 276.367 210.487 277.162 211.077 277.84C211.667 278.517 212.398 279.061 213.222 279.434C214.045 279.807 214.941 280 215.847 280Z"
                fill="#00B0FF"
              />
              <path d="M229.564 272H248.564V273H229.564V272Z" fill="white" />
              <path d="M229.564 266H248.564V267H229.564V266Z" fill="white" />
              <path d="M229.564 259H248.564V261H229.564V259Z" fill="white" />
              <path d="M229.564 252H248.564V254H229.564V252Z" fill="white" />
              <path
                d="M217.564 229.034C219.046 230.422 220.829 231.491 222.79 232.168C224.751 232.845 226.844 233.114 228.926 232.956C231.3 232.753 233.465 231.917 235.549 230.863C237.703 229.774 239.788 228.472 242.173 227.864C244.262 227.332 246.739 227.261 248.533 228.578C248.68 228.685 248.859 228.746 249.044 228.75C249.23 228.755 249.412 228.703 249.564 228.604L249.36 227.286C247.362 225.969 244.934 225.766 242.554 226.217C237.763 227.129 234.126 230.869 229.216 231.406C227.098 231.63 224.954 231.356 222.977 230.606C220.999 229.856 219.25 228.654 217.887 227.109L217.881 227.104L217.564 229.034Z"
                fill="white"
              />
              <path
                d="M75.9471 122.672L45.1236 120L16.2267 133.227L2.6182e-06 358L63.6788 328.511L91 336.08L75.9471 122.672Z"
                fill="#F2F2F2"
              />
              <path
                d="M227.704 120.399C225.106 120.399 223 118.295 223 115.699C223 113.104 225.106 111 227.704 111C230.302 111 232.408 113.104 232.408 115.699C232.408 118.295 230.302 120.399 227.704 120.399Z"
                fill="#00B0FF"
              />
              <path
                d="M228.896 148.047C227.791 148.047 226.894 147.152 226.894 146.047C226.894 144.943 227.791 144.047 228.896 144.047C230.002 144.047 230.898 144.943 230.898 146.047C230.898 147.152 230.002 148.047 228.896 148.047Z"
                fill="#00B0FF"
              />
              <path
                d="M232.064 167C230.684 167 229.564 166.105 229.564 165C229.564 163.895 230.684 163 232.064 163C233.445 163 234.564 163.895 234.564 165C234.564 166.105 233.445 167 232.064 167Z"
                fill="#00B0FF"
              />
              <path
                d="M131 268.563V210.437C130.999 209.261 130.529 208.133 129.693 207.301C128.858 206.469 127.725 206.001 126.544 206H82.4565C81.275 206.001 80.1422 206.469 79.3068 207.301C78.4713 208.133 78.0013 209.261 78 210.437V268.563C78.0013 269.739 78.4713 270.867 79.3068 271.699C80.1422 272.531 81.275 272.999 82.4565 273H126.544C127.725 272.999 128.858 272.531 129.693 271.699C130.529 270.867 130.999 269.739 131 268.563V268.563Z"
                fill="#606060"
              />
              <path
                d="M128 251.5V214.153C127.999 213.052 127.561 211.996 126.783 211.218C126.004 210.439 124.949 210.001 123.848 210H86.1525C85.0516 210.001 83.9961 210.439 83.2176 211.218C82.4392 211.996 82.0013 213.052 82 214.153V265.847C82.0013 266.948 82.4392 268.004 83.2176 268.782C83.9961 269.561 85.0516 269.999 86.1525 270H109.504C114.408 269.994 119.109 268.044 122.576 264.575C126.044 261.107 127.994 256.405 128 251.5Z"
                fill="#404040"
              />
              <path
                d="M122 224C121.999 222.939 121.562 221.923 120.785 221.173C120.008 220.423 118.954 220.001 117.855 220H91.1447C90.0455 220 88.9913 220.421 88.214 221.172C87.4367 221.922 87 222.939 87 224C87 225.061 87.4367 226.078 88.214 226.828C88.9913 227.579 90.0455 228 91.1447 228H117.855C118.954 227.999 120.008 227.577 120.785 226.827C121.562 226.077 121.999 225.061 122 224V224Z"
                fill="#606060"
              />
              <path
                d="M122 237C121.999 235.939 121.562 234.923 120.785 234.173C120.008 233.423 118.954 233.001 117.855 233H91.1447C90.0455 233 88.9913 233.421 88.214 234.172C87.4367 234.922 87 235.939 87 237C87 238.061 87.4367 239.078 88.214 239.828C88.9913 240.579 90.0455 241 91.1447 241H117.855C118.954 240.999 120.008 240.577 120.785 239.827C121.562 239.077 121.999 238.061 122 237V237Z"
                fill="#606060"
              />
              <path
                d="M95.2333 279.279C93.9972 278.767 92.8882 277.991 91.9843 277.004C91.0805 276.017 90.4038 274.843 90.0019 273.566C89.6 272.289 89.4826 270.939 89.6582 269.611C89.8337 268.284 90.2978 267.011 91.0179 265.883L59.1718 236.918L48 193.652L67.8272 192L73.8881 225.952L104.255 263.375C106.069 264.711 107.329 266.668 107.798 268.873C108.267 271.078 107.912 273.378 106.8 275.339C105.688 277.299 103.896 278.783 101.764 279.509C99.6326 280.235 97.3088 280.153 95.2333 279.279V279.279Z"
                fill="#FFB6B6"
              />
              <path
                d="M45.2103 154.114C45.2103 154.114 40.3911 154.185 42.5619 164.191C44.2997 172.201 50.8926 217.278 56.1546 227.363C54.9503 228.405 54.1261 229.82 53.8119 231.383C53.4976 232.947 53.7112 234.571 54.4188 236L76.4126 227.444C78.3296 222.441 75.1153 220.886 73.0642 220.437L73.4667 204.744L70.3137 164.742L48.693 154L45.2103 154.114Z"
                fill="#F2F2F2"
              />
              <path
                d="M38.2224 80.2499C39.2674 87.7705 43.2951 94.5742 49.4206 99.166C55.5462 103.758 63.2685 105.762 70.8907 104.738C78.5128 103.715 85.4114 99.7467 90.0706 93.7064C94.7298 87.6662 96.7684 80.0478 95.7386 72.5251L95.6826 72.1185C94.48 64.6968 90.3692 58.039 84.2371 53.5813C78.1049 49.1236 70.4427 47.2232 62.9035 48.2901C55.3642 49.357 48.5521 53.3057 43.9365 59.2844C39.321 65.2631 37.2719 72.7925 38.2313 80.2487L38.2224 80.2499Z"
                fill="#FFB8B8"
              />
              <path
                d="M45.5195 76.7207L78.5925 75.0236L79.1865 80.9576C79.2111 81.2033 79.0093 81.4124 78.7629 81.3967L48.3081 79.4507L45.5195 76.7207Z"
                fill="#F9F9F9"
              />
              <path
                d="M46.2192 94.4256C44.7477 91.4771 43.2362 88.3115 43.6497 85.0505C44.0632 81.7894 47.3052 78.6724 50.4886 79.6416C52.3922 80.2211 53.831 82.0754 55.8209 82.1703C58.5589 82.3009 60.1287 79.2098 60.9809 76.6398L64.4518 66.1728C67.7848 68.7352 71.65 70.5402 75.7718 71.459C79.8935 72.3777 84.17 72.3877 88.296 71.488C91.5186 70.7612 94.7744 69.3441 96.6647 66.6689C98.555 63.9937 98.5437 59.8441 95.9509 57.8211C94.6795 56.8292 92.9874 56.4524 91.7725 55.394C91.0188 54.7374 90.4994 53.8589 90.2912 52.8885C90.083 51.9181 90.197 50.9074 90.6164 50.0059C91.0357 49.1043 91.7381 48.36 92.6197 47.8829C93.5013 47.4058 94.5151 47.2213 95.5112 47.3567L86.7719 46.2793L89.3757 41.6337C87.4995 43.0927 84.8883 43.2889 82.5371 42.8712C80.1858 42.4536 77.9714 41.4986 75.6712 40.8618C64.6289 37.8044 51.7954 43.1203 46.2762 53.0379C44.1257 52.3295 41.8076 52.2825 39.6293 52.9029C37.451 53.5234 35.5153 54.7821 34.0785 56.5123C31.739 59.4414 31.1027 63.3502 31.0121 67.0782C30.842 74.4287 32.4667 81.7117 35.7492 88.3127C36.6906 90.4095 38.043 92.3019 39.7286 93.8811C40.5772 94.6642 41.5892 95.2545 42.6937 95.6108C43.7981 95.9671 44.9682 96.0807 46.1218 95.9436"
                fill="#2F2E41"
              />
              <path d="M78.5 75L100 72V74.4187L78.5 76.5V75Z" fill="#F9F9F9" />
              <path
                d="M78.5 76L100 74L96.6586 86.9942C95.9767 89.6462 93.5859 91.5 90.8477 91.5H80.9365C79.8571 91.5 78.9724 90.6434 78.9376 89.5645L78.5 76Z"
                fill="#DFF7FF"
                fill-opacity="0.5"
              />
              <path d="M95 74H100L97.098 80H95.3571L95 74Z" fill="#F9F9F9" />
              <path
                d="M99.5 74.2679C99.0425 74.0508 97.4427 73.9651 97.0104 74.2679C96.5781 74.5707 96.2488 75.1033 96.095 75.7486C95.9411 76.3938 95.9752 77.0989 96.1899 77.7087C96.4046 78.3184 96.7822 78.7829 97.2396 79L98.4 76.5L99.5 74.5V74.2679Z"
                fill="#635F5F"
              />
              <path
                d="M84.9917 260.551L84.8849 260.569L84.9678 260.638L87.825 263.038L87.8452 263.055L87.8706 263.048L90.0135 262.448L90.0764 262.431L90.043 262.374L88.6144 259.974L88.5969 259.945L88.5631 259.951L84.9917 260.551Z"
                fill="#EFEFEF"
                stroke="#909090"
                stroke-width="0.1"
              />
              <path
                d="M96.9819 255.62L96.9231 255.643L96.9588 255.695L99.2445 259.028L99.2669 259.061L99.3038 259.047L101.018 258.38L101.077 258.357L101.041 258.305L98.7555 254.972L98.7331 254.939L98.6962 254.953L96.9819 255.62Z"
                fill="#EFEFEF"
                stroke="#909090"
                stroke-width="0.1"
              />
              <path
                d="M95.2311 253.254L87.1257 256.496C86.5065 256.744 86.2721 257.498 86.642 258.053L91.541 265.402C91.8005 265.791 92.2864 265.962 92.7323 265.82L101.243 263.118C101.911 262.906 102.188 262.113 101.797 261.531L96.4924 253.643C96.2162 253.232 95.6907 253.07 95.2311 253.254Z"
                fill="#EFEFEF"
                stroke="#909090"
                stroke-width="0.1"
              />
              <path
                d="M88.2132 258.57C87.8515 258.027 88.0975 257.289 88.7124 257.072L95.2999 254.747C95.7156 254.6 96.1784 254.743 96.4391 255.099L100.689 260.894C101.09 261.441 100.842 262.219 100.199 262.434L93.2246 264.758C92.7968 264.901 92.3265 264.74 92.0763 264.364L88.2132 258.57Z"
                fill="#2F2E41"
              />
              <path
                d="M91 258.001L96.6496 256L98.2454 260.089L92.5958 262.089L91 258.001Z"
                fill="url(#pattern0)"
              />
              <path
                d="M501.451 122.498C491.518 112.573 476.234 113.648 467.473 123.41C466.091 124.95 464.022 122.713 465.523 121.46C476.864 111.989 491.537 111.086 504.419 121.353C505.968 122.587 504.101 124.932 502.551 123.697C502.36 123.545 501.806 122.874 501.451 122.498Z"
                fill="#606060"
              />
              <path
                d="M499.753 126.071C501.338 127.319 499.158 129.633 497.803 128.021C491.2 120.168 478.871 120.045 472.137 128.128C470.866 129.654 468.555 127.732 469.828 126.204C471.982 123.618 485.8 115.091 499.753 126.071Z"
                fill="#606060"
              />
              <path
                d="M492.999 132.552C488.934 127.217 480.652 127.365 476.695 132.633C476.191 133.305 475.315 133.376 474.724 132.932C473.978 132.373 473.975 131.245 474.745 130.683C482.033 125.371 488.397 126.273 495.195 130.576C497.116 131.791 494.777 134.894 492.999 132.552Z"
                fill="#606060"
              />
              <path
                d="M479.631 135.033C483.654 132.822 486.963 133.322 490.407 135.224C492.46 136.384 490.801 138.804 489.183 137.89C488.91 137.736 488.706 137.507 488.582 137.244C487.311 134.564 482.822 134.273 481.362 137.352C480.456 139.262 477.564 137.893 478.471 135.981C478.774 135.341 479.275 135.226 479.631 135.033Z"
                fill="#606060"
              />
              <path
                d="M485.04 146.63C486.991 146.63 488.572 145.048 488.572 143.097C488.572 141.147 486.991 139.565 485.04 139.565C483.089 139.565 481.508 141.147 481.508 143.097C481.508 145.048 483.089 146.63 485.04 146.63Z"
                fill="#606060"
              />
              <path
                d="M146.751 62.9968C150.008 50.7863 142.284 39.3626 130.732 36.9344C128.91 36.5513 129.721 33.9322 131.373 34.5367C143.861 39.1061 151.175 50.1313 148.98 64.7932C148.716 66.5558 146.048 66.1584 146.312 64.394C146.344 64.177 146.617 63.4426 146.751 62.9968Z"
                fill="#606060"
              />
              <path
                d="M143.202 63.2843C142.945 65.0816 140.16 64.425 140.805 62.6435C143.948 53.9613 138.49 44.2993 129.158 42.695C127.397 42.3921 127.853 39.7255 129.617 40.0287C132.602 40.5419 145.471 47.4662 143.202 63.2843Z"
                fill="#606060"
              />
              <path
                d="M135.109 60.9417C137.435 55.3711 133.588 48.9848 127.701 48.2756C126.95 48.1852 126.5 47.5349 126.58 46.8744C126.68 46.0415 127.557 45.5305 128.342 45.8779C135.764 49.1628 137.928 54.527 137.638 61.7626C137.557 63.8063 134.086 63.3822 135.109 60.9417Z"
                fill="#606060"
              />
              <path
                d="M127.152 51.6427C130.688 53.7813 131.789 56.5847 131.859 60.1245C131.88 62.2466 129.247 62.0445 129.23 60.372C129.228 60.0902 129.313 59.8285 129.462 59.6129C130.978 57.4155 129.183 53.7866 126.126 54.0363C124.23 54.1912 123.993 51.321 125.892 51.1659C126.526 51.114 126.842 51.4524 127.152 51.6427Z"
                fill="#606060"
              />
              <path
                d="M120.556 61.0829C121.435 62.6028 123.38 63.1225 124.899 62.2436C126.419 61.3647 126.939 59.4202 126.06 57.9003C125.181 56.3804 123.237 55.8607 121.717 56.7396C120.197 57.6185 119.677 59.563 120.556 61.0829Z"
                fill="#606060"
              />
              <path
                d="M116.574 258.759C119.358 253.086 116.679 246.733 111.248 244.42C110.392 244.056 111.044 242.85 111.795 243.307C117.477 246.761 119.994 252.878 117.493 259.857C117.192 260.696 115.922 260.242 116.223 259.402C116.26 259.298 116.465 258.965 116.574 258.759Z"
                fill="#F9F9F9"
              />
              <path
                d="M114.806 258.556C114.505 259.412 113.203 258.82 113.692 258.008C116.077 254.055 114.338 248.786 109.917 247.093C109.083 246.773 109.565 245.51 110.401 245.83C111.815 246.371 117.455 251.017 114.806 258.556Z"
                fill="#F9F9F9"
              />
              <path
                d="M111.064 256.621C112.746 254.114 111.479 250.608 108.661 249.689C108.301 249.571 108.143 249.209 108.247 248.892C108.377 248.494 108.856 248.328 109.208 248.575C112.529 250.907 113.07 253.748 112.225 257.269C111.986 258.263 110.325 257.718 111.064 256.621Z"
                fill="#F9F9F9"
              />
              <path
                d="M108.064 251.287C109.591 252.679 109.858 254.161 109.549 255.904C109.353 256.947 108.081 256.592 108.236 255.77C108.262 255.632 108.329 255.512 108.423 255.42C109.38 254.49 108.852 252.536 107.328 252.361C106.383 252.253 106.546 250.822 107.492 250.931C107.808 250.967 107.93 251.163 108.064 251.287Z"
                fill="#F9F9F9"
              />
              <path
                d="M103.912 255.277C104.195 256.107 105.099 256.551 105.929 256.268C106.76 255.984 107.204 255.081 106.92 254.25C106.637 253.419 105.734 252.975 104.903 253.259C104.072 253.542 103.628 254.446 103.912 255.277Z"
                fill="#F9F9F9"
              />
              <rect
                x="163"
                y="20"
                width="69"
                height="24"
                rx="6"
                fill="#D42E4C"
              />
              <path
                d="M182.657 31.1669C183.253 31.5625 183.253 32.4375 182.657 32.8331L176.335 37.031C175.67 37.4723 174.782 36.9957 174.782 36.1979V27.8021C174.782 27.0043 175.67 26.5277 176.335 26.969L182.657 31.1669Z"
                fill="white"
              />
              <path
                d="M193.88 37L191.836 33.29H191.262V37H188.868V27.172H192.886C193.661 27.172 194.319 27.3073 194.86 27.578C195.411 27.8487 195.821 28.222 196.092 28.698C196.363 29.1647 196.498 29.6873 196.498 30.266C196.498 30.9193 196.311 31.5027 195.938 32.016C195.574 32.5293 195.033 32.8933 194.314 33.108L196.582 37H193.88ZM191.262 31.596H192.746C193.185 31.596 193.511 31.4887 193.726 31.274C193.95 31.0593 194.062 30.756 194.062 30.364C194.062 29.9907 193.95 29.6967 193.726 29.482C193.511 29.2673 193.185 29.16 192.746 29.16H191.262V31.596ZM202.075 29.09V31.078H205.281V32.926H202.075V35.082H205.701V37H199.681V27.172H205.701V29.09H202.075ZM208.529 32.072C208.529 31.1013 208.739 30.238 209.159 29.482C209.579 28.7167 210.162 28.124 210.909 27.704C211.665 27.2747 212.519 27.06 213.471 27.06C214.638 27.06 215.636 27.368 216.467 27.984C217.298 28.6 217.853 29.44 218.133 30.504H215.501C215.305 30.0933 215.025 29.7807 214.661 29.566C214.306 29.3513 213.9 29.244 213.443 29.244C212.706 29.244 212.108 29.5007 211.651 30.014C211.194 30.5273 210.965 31.2133 210.965 32.072C210.965 32.9307 211.194 33.6167 211.651 34.13C212.108 34.6433 212.706 34.9 213.443 34.9C213.9 34.9 214.306 34.7927 214.661 34.578C215.025 34.3633 215.305 34.0507 215.501 33.64H218.133C217.853 34.704 217.298 35.544 216.467 36.16C215.636 36.7667 214.638 37.07 213.471 37.07C212.519 37.07 211.665 36.86 210.909 36.44C210.162 36.0107 209.579 35.418 209.159 34.662C208.739 33.906 208.529 33.0427 208.529 32.072Z"
                fill="white"
              />
            </g>
            <defs>
              <pattern
                id="pattern0"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlink:href="#image0_423_332"
                  transform="scale(0.000784929 0.00107181)"
                />
              </pattern>
              <clipPath id="clip0_423_332">
                <rect
                  width="630"
                  height="529"
                  fill="white"
                  transform="matrix(-1 0 0 1 630 0)"
                />
              </clipPath>
              <image id="image0_423_332" width="1274" height="933" />
            </defs>
          </svg>
        </div>
      </div>

      <div class="dots">
        <span
          :class="[activeslide === 1 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(1)"
        ></span>
        <span
          :class="[activeslide === 2 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(2)"
        ></span>
        <span
          :class="[activeslide === 3 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(3)"
        ></span>
        <span
          :class="[activeslide === 4 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(4)"
        ></span>
        <span
          :class="[activeslide === 5 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(5)"
        ></span>
        <span
          :class="[activeslide === 6 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(6)"
        ></span>
        <span
          :class="[activeslide === 7 ? 'dot active' : 'dot']"
          v-on:click="goToSlide(7)"
        ></span>
      </div>
    </div>
    <div class="social-proof grid-three">
      <div class="testmonial">
        <p class="text">
          “Great tool with great potential of using in clinical trials”
        </p>
        <div class="col-2">
          <p class="cus-name">- VP Clinical, Ultragenyx</p>
          <!-- <a href="#testimonials">Read More</a> -->
        </div>
      </div>
      <div class="testmonial">
        <p class="text">
          “This technology seems very futuristic and up-and-coming”
        </p>
        <div class="col-2">
          <p class="cus-name">- Manufacturing Manager, Insmed</p>
          <!-- <a href="#testimonials">Read More</a> -->
        </div>
      </div>
      <div class="testmonial">
        <p class="text">“This can be very useful for all the big pharma”</p>
        <div class="col-2">
          <p class="cus-name">- Senior Scientist, Noblegen</p>
          <!-- <a href="#testimonials">Read More</a> -->
        </div>
      </div>
    </div>
    <a class="read-more" href="#testimonials"
      >Read What People Are Saying About Us
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0001 21.2501C11.8101 21.2501 11.6201 21.1801 11.4701 21.0301L5.40012 14.9601C5.11012 14.6701 5.11012 14.1901 5.40012 13.9001C5.69012 13.6101 6.17012 13.6101 6.46012 13.9001L12.0001 19.4401L17.5401 13.9001C17.8301 13.6101 18.3101 13.6101 18.6001 13.9001C18.8901 14.1901 18.8901 14.6701 18.6001 14.9601L12.5301 21.0301C12.3801 21.1801 12.1901 21.2501 12.0001 21.2501Z"
          fill="#000000"
        />
        <path
          d="M12 21.08C11.59 21.08 11.25 20.74 11.25 20.33V3.5C11.25 3.09 11.59 2.75 12 2.75C12.41 2.75 12.75 3.09 12.75 3.5V20.33C12.75 20.74 12.41 21.08 12 21.08Z"
          fill="#000000"
        />
      </svg>
    </a>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      sliderTimer: 0,
      activeslide: 1,
      slidercount: 7,
      sliderinterval: 10000,
    };
  },
  mounted: function () {
    this.startSlider();
  },
  methods: {
    startSlider: function () {
      let self = this;
      this.sliderTimer = setInterval(function () {
        self.nextSlide();
      }, 10000);
    },

    prevSlide: function () {
      if (this.activeslide == 1) {
        this.activeslide = this.slidercount;
      } else {
        this.activeslide = this.activeslide - 1;
      }
    },

    nextSlide: function () {
      if (this.activeslide == this.slidercount) {
        this.activeslide = 1;
      } else {
        this.activeslide = this.activeslide + 1;
      }
    },

    goToSlide: function (slideIndex) {
      this.activeslide = slideIndex;
      clearInterval(this.sliderTimer);
      this.startSlider();
    },

    showForm() {
      // const form = document.getElementById("email-drop");
      // form.classList.toggle("show");

      this.$emit("toggleShowForm");
    },
  },
};
</script>

<style>
#hero-section {
  padding: 4rem 0;
  background: #fcfaf9;
  background: linear-gradient(
    254.75deg,
    rgba(128, 217, 255, 0.87) 3.48%,
    rgba(128, 179, 254, 0.9) 9.19%,
    rgba(178, 144, 239, 0.65) 34.62%,
    rgba(128, 219, 255, 0.8) 55.38%,
    rgba(151, 220, 247, 0.890278) 85.48%,
    rgba(159, 223, 249, 0.9) 92.74%,
    rgba(194, 169, 239, 0.51) 103.12%
  );

  /* filter: blur(8px); */
  display: grid;
  place-items: center;
  grid-template-columns: 1fr;
}

.hero-slider {
  position: relative;
  display: grid;
  place-items: center;
  grid-row: 1 / 2;
  grid-column: 1/2;
  padding: 2rem 0;
}

/* The dots/bullets/indicators */

.dots {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  text-align: center;
  display: flex;
}

.dot {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #f0f0f0b0;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.dot.active {
  background-color: var(--dark-grey);
}

.right {
  margin-top: 4em;
}

.hero-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1.2em;
  padding-bottom: 4em;
}

.hero-image .img {
  /* width: clamp(200px, 80vw, 650px); */
  width: min(80vw, 550px);
  height: auto;
}

.hero-image svg.img {
  aspect-ratio: 630 / 529;
}

.problem-list {
  background-color: rgba(255, 250, 252, 0.4);
  backdrop-filter: blur(
    6px
  ); /* Note: backdrop-filter has minimal browser support */
  border-radius: 2em;
  padding: 3em;

  display: flex;
  flex-direction: column;
  gap: 2em;
}

.problem {
  display: flex;
  gap: 1.4em;
  align-items: center;
}

.problem h4 {
  font-weight: 300;
  font-style: italic;
  font-size: clamp(1.1rem, 2vw, 1.3rem);

  padding: 0 0.3em 0.2em;
  text-decoration: line-through;
  /* background-image: repeating-linear-gradient(var(--degree), transparent 0%, transparent 48%, #000 50%, transparent 52%, transparent 100%); */
}

#hero-section .social-proof {
  padding-top: 4rem;
}

#hero-section .grid-three {
  display: grid;
  grid-template-columns: 1fr;
  width: 90%;
  gap: 2rem;
  justify-content: space-evenly;
  align-items: stretch;
}

#hero-section .testmonial {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(
    6px
  ); /* Note: backdrop-filter has minimal browser support */

  border-radius: 12px;
  padding: 1rem 2rem;
}

p.text {
  line-height: 1.8em;
  margin-block: 0;
  font-style: italic;
}

p.cus-name {
  font-size: clamp(0.8rem, 1vw, 1rem);
  line-height: 1em;
  font-weight: 600;
}

#hero-section .col-2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#hero-section a.read-more {
  margin-top: 2rem;
  font-size: clamp(0.8rem, 1vw, 1rem);
  font-weight: 600;
  color: #000;
  line-height: 1em;
}

#hero-section a.read-more:hover {
  color: var(--accent-blue);
}

#hero-section a.read-more:hover svg path {
  fill: var(--accent-blue);
}

/*---------------------------------  CSS Animations ----------------------------*/

.slides.grid {
  /* transition: all 2s ease-in-out; */
  display: none;
}

.slides.grid.active {
  display: grid;
  align-items: center;
  gap: 1rem;
}

.slides.active .left {
  /* opacity: 1; */
  animation: fadeRight 10s ease-in-out;
}

.slides.active .right {
  /* opacity: 1; */
  animation: fadeLeft 10s ease-in-out;
}

.slides .inner {
  opacity: 0;
}

.slides.active .inner {
  animation: fadeUp 10s ease-in-out var(--delay);
}

/* .slide.active .left {
        animation: fadeInUp 2s ease-in-out forwards;
    } */

@keyframes fadeLeft {
  0% {
    opacity: 0;
    transform: translateX(50%);
  }

  25%,
  75% {
    opacity: 1;
    transform: translateX(0);
  }

  100% {
    opacity: 0;
    transform: translateX(50%);
  }
}

@keyframes fadeRight {
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }

  25%,
  75% {
    opacity: 1;
    transform: translateX(0);
  }

  100% {
    opacity: 0;
    transform: translateX(-50%);
  }
}

@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(10rem);
  }

  15%,
  70% {
    opacity: 1;
    transform: translateX(0);
  }

  100% {
    opacity: 0;
    transform: translateY(10rem);
  }
}

@media only screen and (min-width: 1025px) {
  .right {
    margin-top: 0;
  }

  .slides {
    min-height: 600px;
  }

  .hero-text.left {
    padding-right: 1em;
  }

  .hero-text.right {
    padding-left: 1em;
  }

  .hero-image.left {
    padding-right: 1em;
  }

  .hero-image.right {
    margin-top: 0;
    padding-left: 1em;
  }

  #hero-section .social-proof {
    padding-top: 2rem;
  }

  #hero-section .grid-three {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
}
</style>
